(function() {
    var hideProgressPromises = [],
        hideProgressForce,
        showProgressTimeout;

    fpUtil = fp.util = {
        regExp: {
            escape:function(value) {
                if(!value) return value;
                this.matchEscape.lastIndex = 0;
                return value.toString().replace(this.matchEscape, '\\$1');
            },
            matchEscape: /([.?*+^$[\]\\(){}|-])/g,
            matchAlphanumeric: /[a-z0-9]/i,
            matchNumeric: /\d+/g,
            matchFloat: /(\d+)?(\.\d+)?/g,
            matchItemId: /^[a-z0-9\-_]+$/i,
            matchSpecialChars: /[\:\-\_]/g,
            matchNonAlphanumeric: /[^a-zA-Z0-9-_]+/g,
            matchHtml: /(<([^>]+)>)/gi,
            matchTag: /(<([^>]+)>)/gmi,
            matchDurationFormat: /(HH?)|(mm?)|(ss?)|(SSS?)/g,
            matchServerDateTime: /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}( [+-]?\d{4})?$/i,
            matchServerDate: /^\d{4}-\d{2}-\d{2}$/i,
            matchFormXssInvalidChars: /(?:<|>|`)/,
            matchJsonXssInvalidChars: /[&<>"`']/gmi,
            matchNonNameChars: /\d+\//,
            matchSlash: /\//g,
            matchDataId: /data-id=(['"])?(.*?)\1/i,
            matchFreshopTemplate: /<([A-Z0-9]*)(.*?type=(['"]?)text\/(fp-)?template\3.*?)>([\s\S]*?)<\/\1>/gim,
            matchDataTemplate: /<([A-Z0-9]*).*?data-render-template=(['"])(.*?)\2.*?>([\s\S]*?)<\/\1>/gim,
            matchDataModule: /<([A-Z0-9]*)(.*?data-module=(['"]?).*?\3.*?)>([\s\S]*?)<\/\1>/gim,
            matchLayout: /component\/(\d+)\//,
            matchRoute: /({{(.*?)}})(.*)/,
            matchHost: /^.+:\/\/.*?\//,
            matchUrl: /(https?:.*?\/\/.*?)(\/([a-z]{2,2}(?!\w)(-[a-z]{2,4})?)?.*)/,
            matchCanonicalUrl: /(https?:.*?\/\/.*?)(\/.*?)(\/\w\/.*)/,
            matchMediaClass: /(fp-media-\S{2}\s?)+/gi,
            matchLayoutClass: /fp-layout-\S+/gim,
            matchColumnClass: /col-(xs|sm|md|lg)-\S+/gim,
            matchPageTemplateClass: /page-template-(default|page-.*?)\s|(single-.*?)\s/,
            matchCacheKey: /[^\w\s]|_/g,
            matchPhone: /(\+?(\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4})|(\+?(\d{1})?\d{10})/g,
            matchSanitizeBlacklist: /^(error|warning|success|message)/,
            matchAlphabet: /[a-zA-Z]/g,
            matchWrapperFunction: /^\(function([\s\t]?)+\(\)([\s\t]?)+{([\s\n]?)+(.*)([\s\t]?)}\);/gmis
        },
        encodeForHtml: $.proxy(_.escape, _),
        decodeForHtml: $.proxy(_.unescape, _),
        encodeForHtmlAttribute: $.proxy(_.escape, _),
        decodeForHtmlAttribute: $.proxy(_.unescape, _),
        sanitize: function(value, stripHtml, stripUrl) {
            value = S.getString(value);
            if(this.getBoolean(stripHtml, true)) {
                this.regExp.matchTag.lastIndex = 0;
                value = value.replace(this.regExp.matchTag, '');
            }
            if(stripUrl) value = value.replace(/((?:https?:\/\/)?(?:www\d{0,3}\.)?\w*(\.\w{1,3}|:\d+)).*?(\s|$)/gmi, '');
            return value;
        },
        getValue: function(value, defaultValue) {
            return this.isNull(value) ? defaultValue : value;
        },
        getStateValue: function(state, value, altValue) {
            return this.getBoolean(state) ? value : altValue;
        },
        getBoolean: function(value, defaultValue) {
            //default to false
            defaultValue = (defaultValue != null && defaultValue === true) ? true : false;

            if(_.isFunction(value)) value = value();

            if(this.isNull(value)) return defaultValue;
            if(value === true || value === false) return value;

            value = S(value).trim().toLowerCase().s;

            if(value === 'false' || value === '0' || value === 'no') return false;
            else if(value) return true;

            return defaultValue;
        },
        getId: function(value) {
            value = S(value).trim().getString('0').s;
            return value != '0' ? value : undefined;
        },
        //returns cloned o1 object excluding fields in which field values from o1 and o2 are equal
        getChanged: function(o1, o2, emptyIsUndefined) {
            var changed = $.extend(true, {}, o1),
                value1,
                value2;
            if(_.isArray(changed) && _.isEqual(changed, o2)) return changed;
            else if(_.isObject(changed)) {
                for(var key in changed) {
                    var isDateField = key == 'date' || S(key).endsWith('_date');
                    //if (isDateField && key in o2 && key in changed && _.has(o2[key], 'date') && _.has(changed[key], 'date')) {
                    //    if(_.isEqual(changed[key].date, o2[key].date)) delete changed[key];
                    //    continue;
                    //}
                    if (isDateField && _.has(o2, key) && _.has(changed, key)) {
                        //server gives time with 'UTC' but UI does not put 'UTC' in time string
                        if (_.isEqual(S(changed[key]).trimRight(' UTC', true), S(o2[key]).trimRight(' UTC', true))) {
                            delete changed[key];
                        }
                    }
                    if (key.charAt(0) === '_') continue;
                    if (_.isEqual(value1 = changed[key], value2 = o2[key])) delete changed[key];
                    else if(emptyIsUndefined && (
                            (_.isUndefined(value1) && _.isString(value2) && !value2) ||
                            (_.isUndefined(value2) && _.isString(value1) && !value1)
                        )
                    ) {
                        delete changed[key];
                    }
                }
            }
            return changed;
        },
        //returns new object where values which are equal from obj1 and obj2 are removed
        getUnique: function(obj1, obj2, unique) {
            unique = _.getObject(unique);
            if(_.isObject(obj1) && _.isObject(obj2)) {
                var props = {};
                for(var key in obj1) {
                    if(!_.isEqual(obj1[key], obj2[key])) unique[key] = obj1[key];
                    props[key] = 1;
                }
                for(var key in obj2) {
                    if(props[key]) continue;
                    if(!_.isEqual(obj2[key], obj1[key])) unique[key] = obj2[key];
                }
            }
            return unique;
        },
        urlParams: function(options) {
            var url;
            if(_.isString(options)) {
                url = options;
                options = null;
            }

            options = $.extend({
                includeSearch: true, //non-hash parameters i.e. https://www.freshop.com/?test=1
                includeRouteSearch: true //hash parameters i.e. https://www.freshop.com!#/?test=1. hash parameters will take priority over non-hash parameter
            }, options);

            url = S.getString(url || options.url, window.location.href);

            var params = {},
                urlParts = url.split(fp.routeDelimiter);

            if(options.includeSearch) {
                var searchParts = urlParts[0].split('?'),
                    search = S(searchParts[1]).trim(),
                    matchSanitizeBlacklist = this.regExp.matchSanitizeBlacklist,
                    sanitizeUrlOnly,
                    param,
                    key,
                    value;

                if(search.length > 2) {
                    //if(options.includeRouteSearch) search = search.trimRight('/');
                    _.each(search.split('&'), function (item) {
                        param = item.split('=');
                        if (param.length == 2) {
                            value = S(param[1]).trim().replace(/\+/g, ' ').s;
                            try {
                                value = decodeURIComponent(value);
                            }
                            catch (exc) {}
                            key = S(param[0]).trim().s;
                            sanitizeUrlOnly = key && key.match(matchSanitizeBlacklist);
                            value = fpUtil.sanitize(value, !sanitizeUrlOnly, sanitizeUrlOnly);
                            params[key] = value;
                        }
                    });
                }
            }

            if(options.includeRouteSearch && urlParts[1]) {
                search = S(urlParts[1]).trim();
                if (!search.contains('?')) search = search.prepend('?');
                if (search.length > 3) {
                    params = $.extend(params, this.urlParams({url: search.s, includeRouteSearch: false}));
                }
            }

            return params;
        },
        urlSearch: function(params, enableQ) {
            var result = '';
            if(_.isObject(params)) {
                var value;
                for(var key in params) {
                    value = params[key] || '';
                    result += (result ? '&' : '') + (key + '=' + encodeURIComponent(value));
                }
                result = (result && this.getBoolean(enableQ, true) ? '?' : '') + result;
            }
            return result;
        },
        routeUrlParams: function(updateParams, replace, baseUrl, url) {
            if(_.isObject(updateParams)) {
                var params = updateParams;
                if(!replace) params = this.routeUrlParams(null, null, null, url);

                for(var key in updateParams) {
                    if(updateParams[key] != null) params[key] = updateParams[key];
                    else delete params[key];
                }

                var newParams = $.param(params);
                newParams = newParams ? '?' + newParams : '';

                if(baseUrl) {
                    if(baseUrl.indexOf(fp.routeDelimiter) < 0) baseUrl = S(baseUrl).trailingSlashIt().s + fp.routeDelimiter + '/';
                    fp.ui.router.stateManager.go(baseUrl + newParams, null, {absolute: true});
                    return;
                }

                var route = this.getRouterRoute(url).join('/');
                this.routeParams(route + newParams, true, null, url);
            }
            else {
                url = url || window.location.href;
                var search = S.getString(url.split(fp.routeDelimiter)[1]).split('?');
                search = '?' + S(search[1]).trim().s;
                params = this.urlParams(search);

                return params;
            }
        },
        routeParams: function(updateParams, replace, baseRoute, url) {
            baseRoute = baseRoute || '';
            var route;
            if(replace) route = this.getRouterRoute(url);
            else {
                url = url ? fp.routeDelimiter + url.split(fp.routeDelimiter)[1] : window.location.hash;
                route = S(url).trimLeft(fp.routeDelimiter).trimLeft('/').split('/').s;
            }

            //assume that the first element in route is the base page
            if(baseRoute && route[0] == baseRoute) route.shift();

            if(updateParams != null || replace) {
                if(_.isObject(updateParams)) {
                    var newRoute = [],
                        urlParams = '',
                        temp;

                    if(!replace) {
                        for(var n=0;n<route.length;n++) {
                            temp = route[n].split('?');
                            if(temp[0]) newRoute.push(temp[0]);
                            if(temp[1]) urlParams = '?' + temp[1];
                        }
                    }

                    var notFoundValues = [];
                    for(key in updateParams) {
                        var index = $.inArray(key, newRoute);
                        if(index >= 0) newRoute[index+1] = updateParams[key];
                        else notFoundValues.push(key, updateParams[key]);
                    }

                    newRoute = newRoute.concat(notFoundValues);
                    newRoute = newRoute.join('/');

                    if(baseRoute) newRoute = '/' + baseRoute + '/' + newRoute;
                    if(!S(newRoute).endsWith('/')) newRoute += '/';

                    newRoute += urlParams;
                }
                else newRoute = updateParams;

                this.setRoute(newRoute);
            }
            else {
                var params = {},
                    temp;

                if(baseRoute && baseRoute == route[0]) route.shift();

                for(var n=0;n<route.length;n++) {
                    temp = route[n].split('?');

                    if(temp[0]) route[n] = temp[0];
                    else if(temp[1]) route.splice(n, 1);
                }

                for(var n=0;n<route.length;n+=2) {
                    if(route[n]) params[route[n]] = route[n+1];
                }

				return params;
			}
		},
		getRoute: function(baseUrl, fragment, allowClientApiParams) {
            baseUrl = S(baseUrl);
            fragment = S(fragment).trimRight('/');

            if(this.isNull(allowClientApiParams)) {
                var shopState = fpUi.router.stateManager.states.shop,
                    shoppingUrlPath = shopState && shopState.self ? S(shopState.self.url).trimRight(fp.routeDelimiter + '/').s : fpConfig.urls.shopping;
                if(
                    baseUrl.startsWith(shoppingUrlPath, true)
                    || baseUrl.startsWith(fpConfig.urls.circular, true)
                ) {
                    allowClientApiParams = true;
                }
            }

            if(baseUrl.indexOf('#') == -1) baseUrl = baseUrl.concat(fp.routeDelimiter);
            else if(baseUrl.indexOf(fp.routeDelimiter) == -1) baseUrl = baseUrl.replace('#', fp.routeDelimiter);

            if(baseUrl.endsWith(fp.routeDelimiter) || !fragment.endsWith('?')) {
                baseUrl = baseUrl.concat('/');
            }

            var route = baseUrl.s + fragment.s;
            if(allowClientApiParams) {
                var params = this.routeUrlParams(),
                    paramValue,
                    hashParams = '';
                for(var param in fp.defaultStoreRequiredApiParams) {
                    paramValue = params[param];
                    if(paramValue) {
                        if(hashParams) hashParams += '&';
                        hashParams += param + '=' + encodeURIComponent(paramValue);
                    }
                }
                if(hashParams) {
                    if(!S(route).contains('?')) {
                        hashParams = '?' + hashParams;
                        if(!S(route).endsWith('/')) route += '/';
                    }
                    else hashParams = '&' + hashParams;
                    route += hashParams;
                }
            }
            return route;
        },
        getRouterRoute: function(url) {
            var route = S(S(S(url || window.location.hash)
                .split(fp.routeDelimiter)[1])
                .split('?')[0])
                .trimLeft('/')
                .split('/');

            return route;
        },
        setRoute: function(route, replace, baseUrl) {
            route = S(route).ensureLeft('/').s;
            var loc = window.location;
            if(replace) {
                if(!baseUrl) baseUrl = loc.href.split('#')[0];
                loc.replace(baseUrl + fp.routeDelimiter + route);

                //fp.log('location.replace', baseUrl + '#' + route);
                return;
            }

            loc.hash = fp.routeDelimiter + route;
        },
        attrParams: function(value, delimiter) {
            var params = {};
            value = S(value).trim().s;
            if(!value) return params;

            var param,
                paramValue;

            delimiter = delimiter || ',';

            value = value.split(delimiter);

            for(var n=0;n<value.length;n++) {
                param = value[n].split('=');
                if(param.length == 2) {
                    paramValue = S(param[1]).trim().replace(/\+/g, ' ').s;
                    try {
                        paramValue = decodeURIComponent(paramValue);
                    }
                    catch(exc){}

                    //remove quotes
                    paramValue = S(paramValue).trim('"').trim('\'').s;
                }
                else paramValue = '';
                params[S(param[0]).trim().s] = paramValue;
            }

            return params;
        },
        getAttrs: function(obj, delimiter) {
            if(!_.isObject(obj)) return obj + '';

            delimiter = delimiter || ' ';
            var attrs = '';
            _.each(obj, function(value, key) {
                if(attrs) attrs += delimiter;
                if(key) attrs += key + '=';
                attrs += '"' + (value || '') + '"';
            });
            return attrs;
        },
        isNull: function(value) {
            return !(value != null);
        },
        isDefined: function(value) {
            return value !== undefined;
        },
        isNullOrEmpty: function(value) {
            return !S.getString(value).length;
        },
        isNumeric: function(value) {
            return !isNaN(parseFloat(value)) && isFinite(value);
        },
        isInteger: function(value) {
            if(!this.isNumeric(value)) return false;
            return value === +value && value === (value|0);
        },
        isFloat: function(value) {
            if(!this.isNumeric(value)) return false;
            return value === +value && value !== (value|0);
        },
        isDateString: function(value) {
            value = S(value).trim().s;
            if(!value) return;
            if(value.match(this.regExp.matchServerDate)) return true;
            return value.match(this.regExp.matchServerDateTime) != null;
        },
        isPromise: function(value) {
            return _.isObject(value) && _.isFunction(value.promise);
        },
        getInteger: function(value, defaultValue) {
            if(this.isInteger(value)) return value;

            value = parseInt(value, 10);
            if(!this.isInteger(value)) value = this.getInteger(defaultValue, 0);

            return value;
        }
        ,getFloat: function(value, defaultValue) {
            if(this.isFloat(value)) return value;

            var returnValue = value;
            if(returnValue && _.isString(returnValue)) {
                var regExp = this.regExp.matchFloat;
                regExp.lastIndex = 0;
                var match = returnValue.match(regExp);

                if(match) {
                    returnValue = parseFloat(match.join(''));
                    if(!isNaN(returnValue) && S(value).endsWith('%')) {
                        returnValue /= 100;
                    }
                }
                else returnValue = 0;
            }
            else returnValue = parseFloat(returnValue);

            if(isNaN(returnValue)) {
                returnValue = this.getFloat(defaultValue, 0);
            }

            return returnValue;
        }
        ,getOrdinal: function(value, concat) {
            concat = this.getBoolean(concat, true);

            if(!value || !this.isInteger(value)) return '';

            var ordinal = fpConstants.ordinal,
                index = value % 100;

            return (concat ? value : '') + (ordinal[(index - 20) % 10] || ordinal[index] || ordinal[0]);
        }
        ,getMin: function(value /* , ..., value */) {
            var args = [];
            _.each(arguments, function(value) {
                if(value != null && S(value).trim().s) args.push(value);
            });

            return Math.min.apply(Math, args);
        }
        ,formatString: function (value) {
            if(!value) return '';

            var args = _.toArray(arguments).slice(1);
            return value.replace(/{(\d+)}/g, function(match, index) {
                return S.getString(args[index]);
            });
        },
        formatDate: function(date, format, inputFormat, defaultValue) {
            defaultValue = S.getString(defaultValue, date);
            if(!date) return defaultValue;

            if(_.isString(date)) {
                inputFormat = S.getString(inputFormat, fp.serverDateTimeFormat);

                if(fp.moment) date = fp.moment(date, inputFormat).toDate();
                else date = dateFns.parse(date, inputFormat)
            }
            format = S.getString(format, fpConfig.dateTimeFormat);

            if (dateFns.isValid(date)) value = dateFns.format2(date, format);
            else value = defaultValue;

            return value;
        },
        formatFulfillmentSlotDateTimeLabel: function(dateTimeLabel) {
            if(dateFns.isToday(dateTimeLabel.date)) {
                return fp.ui.localef('shared-today-between-date', 'Today,{0}{1}', fp.config.fulfillmentDateTimeHasEndTimeDelimiter, dateTimeLabel.timeLabel);
            }
            else if(dateFns.isTomorrow(dateTimeLabel.date)) {
                return fp.ui.localef('shared-tomorrow-between-date', 'Tomorrow,{0}{1}', fp.config.fulfillmentDateTimeHasEndTimeDelimiter, dateTimeLabel.timeLabel);
            }
            else {
                return fp.ui.localef('shared-between-date', '{0},{1}{2}', dateFns.format2(dateTimeLabel.date, fp.config.fulfillmentShortDateFormat), fp.config.fulfillmentDateTimeHasEndTimeDelimiter, dateTimeLabel.timeLabel);
            }
        },
        // var $input = $(fpUtil.formatString('<input type="text" value="{0}" />', value)).mask(fpConfig.localePhone.default_format);
        // value = fpUi.getInputValue($input);
        // $input.unmask();
        formatPhone: function(value) {
            if(!_.isString(value)) value = '';
            else if(value && fpConfig.localePhone.format_input) {
                var $input = $(fpUtil.formatString('<input type="text" value="{0}" />', value)).mask(fpConfig.localePhone.default_format);
                value = $input.masked();
                $input.unmask();
            }
            return value;
        },
        getDateFormat: function(value) {
            if(_.isString(value)) {
                if (S(value).contains('/')) {
                    if (value.length > fpConfig.dateFormat.length) return fpConfig.dateTimeFormat;
                    return fpConfig.dateFormat;
                }
                else if (value.length > fp.serverDateFormat.length) return fp.serverDateTimeFormat;
            }
            return fp.serverDateFormat;
        },
        getNullIfEmpty: function(value, defaultValue) {
            value = S(value).trim().s;
            if(!_.size(value)) value = S(defaultValue).trim().s;
            if(!_.size(value)) value = null;

            return value;
        },
        getUndefinedIfEmpty: function(value, defaultValue) {
            value = S(value).trim().s;
            if(!_.size(value)) value = S(defaultValue).trim().s;
            if(!_.size(value)) value = undefined;

            return value;
        },
        coreNutrition: [
            'total_fat',
            'sat_fat',
            'trans_fat',
            'cholesterol',
            'sodium',
            'carbo',
            'fiber',
            'sugar',
            'protein'
        ],
        optionalNutrition: [
            'vitamin_a'
            ,'vitamin_c'
            ,'calcium'
            ,'iron'
            ,'potassium'
            ,'vitamin_d'
            ,'vitamin_e'
            ,'vitamin_k'
            ,'thiamin'
            ,'riboflavin'
            ,'niacin'
            ,'vitamin_b6'
            ,'folate'
            ,'vitamin_b12'
            ,'biotin'
            ,'pantothenic_acid'
            ,'phosphorus'
            ,'iodine'
            ,'magnesium'
            ,'zinc'
            ,'selenium'
            ,'copper'
            ,'manganese'
            ,'chromium'
            ,'molybdenum'
            ,'cloride'
        ],
        states: [
            {value: 'AL', name: 'Alabama'}
            ,{value: 'AK', name: 'Alaska'}
            ,{value: 'AZ', name: 'Arizona'}
            ,{value: 'AR', name: 'Arkansas'}
            ,{value: 'CA', name: 'California'}
            ,{value: 'CO', name: 'Colorado'}
            ,{value: 'CT', name: 'Connecticut'}
            ,{value: 'DE', name: 'Delaware'}
            ,{value: 'DC', name: 'District Of Columbia'}
            ,{value: 'FL', name: 'Florida'}
            ,{value: 'GA', name: 'Georgia'}
            ,{value: 'HI', name: 'Hawaii'}
            ,{value: 'ID', name: 'Idaho'}
            ,{value: 'IL', name: 'Illinois'}
            ,{value: 'IN', name: 'Indiana'}
            ,{value: 'IA', name: 'Iowa'}
            ,{value: 'KS', name: 'Kansas'}
            ,{value: 'KY', name: 'Kentucky'}
            ,{value: 'LA', name: 'Louisiana'}
            ,{value: 'ME', name: 'Maine'}
            ,{value: 'MD', name: 'Maryland'}
            ,{value: 'MA', name: 'Massachusetts'}
            ,{value: 'MI', name: 'Michigan'}
            ,{value: 'MN', name: 'Minnesota'}
            ,{value: 'MS', name: 'Mississippi'}
            ,{value: 'MO', name: 'Missouri'}
            ,{value: 'MT', name: 'Montana'}
            ,{value: 'NE', name: 'Nebraska'}
            ,{value: 'NV', name: 'Nevada'}
            ,{value: 'NH', name: 'New Hampshire'}
            ,{value: 'NJ', name: 'New Jersey'}
            ,{value: 'NM', name: 'New Mexico'}
            ,{value: 'NY', name: 'New York'}
            ,{value: 'NC', name: 'North Carolina'}
            ,{value: 'ND', name: 'North Dakota'}
            ,{value: 'OH', name: 'Ohio'}
            ,{value: 'OK', name: 'Oklahoma'}
            ,{value: 'OR', name: 'Oregon'}
            ,{value: 'PA', name: 'Pennsylvania'}
            ,{value: 'RI', name: 'Rhode Island'}
            ,{value: 'SC', name: 'South Carolina'}
            ,{value: 'SD', name: 'South Dakota'}
            ,{value: 'TN', name: 'Tennessee'}
            ,{value: 'TX', name: 'Texas'}
            ,{value: 'UT', name: 'Utah'}
            ,{value: 'VT', name: 'Vermont'}
            ,{value: 'VA', name: 'Virginia'}
            ,{value: 'WA', name: 'Washington'}
            ,{value: 'WV', name: 'West Virginia'}
            ,{value: 'WI', name: 'Wisconsin'}
            ,{value: 'WY', name: 'Wyoming'}
            ,{value: 'AB', name: 'Alberta'}
            ,{value: 'BC', name: 'British Columbia'}
            ,{value: 'MB', name: 'Manitoba'}
            ,{value: 'NB', name: 'New Brunswick'}
            ,{value: 'NL', name: 'Newfoundland and Labrador'}
            ,{value: 'NS', name: 'Nova Scotia'}
            ,{value: 'ON', name: 'Ontario'}
            ,{value: 'PE', name: 'Prince Edward Island'}
            ,{value: 'QC', name: 'Quebec'}
            ,{value: 'SK', name: 'Saskatchewan'}
        ]
        ,sort: function(array, key, desc) {
            if(!(_.isArray(array) && array.length > 1)) return array;
            key = (key && _.isObject(array[0])) ? key : null;
            var self = this;
            array.sort(function(a, b) {
                return self.sortHelper(a, b, key, desc);
            });
            return array;
        }
        ,sortHelper: function(a, b, key, desc) {
            if(key) {
                a = a[key];
                b = b[key];
            }

            a = a || 0;
            b = b || 0;

            if(_.isString(a)) {
                if(this.isDateString(a)) a = dateFns.parse(a);
                else a = this.isNumeric(a) ? parseFloat(a) : a.toLowerCase();
            }
            if(_.isString(b)) {
                if(this.isDateString(b)) b = dateFns.parse(b);
                else b = this.isNumeric(b) ? parseFloat(b) : b.toLowerCase();
            }

            if(_.isDate(a) && _.isDate(b)) {
                return desc ? b - a : a - b;
            }

            if(desc) return (a == b) ? 0 : (b > a) ? 1 : -1;
            return (a == b) ? 0 : (a > b) ? 1 : -1;
        }
        /***
         Copyright 2013 Teun Duynstee
         https://github.com/Teun/thenBy.js/tree/master
         */
        ,sortFirstBy: (function() {
            function identity(v){return v;}

            function ignoreCase(v){return typeof(v)==="string" ? v.toLowerCase() : v;}

            function makeCompareFunction(f, opt){
                opt = typeof(opt)==="number" ? {direction:opt} : opt||{};
                if(typeof(f)!="function"){
                    var prop = f;
                    // make unary function
                    f = function(v1){return !!v1[prop] ? v1[prop] : "";}
                }
                if(f.length === 1) {
                    // f is a unary function mapping a single item to its sort score
                    var uf = f;
                    var preprocess = opt.ignoreCase?ignoreCase:identity;
                    f = function(v1,v2) {return preprocess(uf(v1)) < preprocess(uf(v2)) ? -1 : preprocess(uf(v1)) > preprocess(uf(v2)) ? 1 : 0;}
                }
                if(opt.direction === -1)return function(v1,v2){return -f(v1,v2)};
                return f;
            }

            /* adds a secondary compare function to the target function (`this` context)
             which is applied in case the first one returns 0 (equal)
             returns a new compare function, which has a `thenBy` method as well */
            function tb(func, opt) {
                var x = typeof(this) == "function" ? this : false;
                var y = makeCompareFunction(func, opt);
                var f = x ? function(a, b) {
                    return x(a,b) || y(a,b);
                }
                    : y;
                f.thenBy = tb;
                return f;
            }
            return tb;
        })()
        ,prepareJsonData: function(data, sort) {
            if(!sort) return data;

            if(_.isArray(data)) {
                if(_.has(_.firstObject(data), sort.name)) {
                    // fp.log('will sort', sort, data);
                    this.sort(data, sort.name, sort.value === 'desc');
                }

                for(var n=0;n<data.length;n++) {
                    data[n] = this.prepareJsonData(data[n], sort);
                }
            }
            else if(_.isObject(data) && !_.isFunction(data)){
                var value;

                for(var key in data) {
                    value = data[key];
                    if(_.isObject(value) && !_.isFunction(value)) {
                        data[key] = this.prepareJsonData(value, sort);
                    }
                    // else if(key === 'id' || S(key).endsWith('_id')) {
                    //     data[key] = S.getString(value);
                    // }
                }
            }
            return data;
        }
        ,ensureSort: function(payload) {
            if(!_.isObject(payload)) return;

            var field;

            if(payload.sort) {
                _.each(S.getString(payload.sort).split(','), function(value, key) {
                    field = S(value).trimRight('!');
                    if(!field.length || payload[field.s + '_sort']) return;

                    payload[field.s + '_sort'] = fpUtil.getStateValue(S(value).endsWith('!'), 'desc', 'asc');
                });
            }
            else {
                //until all api's support new sorting style
                //pass in old style of sorting

                var sort = '';
                _.each(payload, function(value, key) {
                    key = S(key);
                    if(!key.endsWith('_sort')) return;

                    field = key.trimRight('_sort');
                    if(!field.length) return;

                    if(sort) sort += ',';
                    sort += field.s + fpUtil.getStateValue(value == 'desc', '!', '');
                });

                if(sort) payload.sort = sort;
                else delete payload.sort;
            }

            if(!payload.sort) return;

            //ensure sequence is passed in payload.fields
            var fields = S(payload.fields).trim();
            if(fields.length) {
                fields = fields.split(',');
                if (!_.contains(fields, 'sequence')) {
                    fields.push('sequence');
                    payload.fields = fields.join();
                }
            }
        }
        ,isJQuery: function(value) {
            return value instanceof $;
        }
        ,isEvent: function(value) {
            return _.isObject(value) &&  _.isFunction(value.preventDefault);
        }
        ,isSequenceObject: function(item) {
            return _.isObject(item) &&  _.has(item, 'sequence');
        }
        ,isProduct: function(item) {
            return _.isObject(item) && !this.isProductWrapper(item) && _.has(item, 'name');
        }
        ,isRecipe: function(item) {
            return _.isObject(item) && _.has(item, 'name') && _.hasAny(item, ['attribution', 'difficulty_level_id', 'serves']);
        }
        ,isGeneric: function(item) {
            return _.isObject(item) && !_.has(item, 'product_id');
        }
        ,isListItem: function(item) {
            return _.isObject(item) && _.hasAny(item, ['product_id', 'shopping_list_id']);
        }
        ,isOrder: function(item) {
            return _.has(item, ['id', 'store_id', 'user_id']);
        }
        ,isOrderItem: function(item) {
            return this.isProductWrapper(item) && _.has(item, 'order_id');
        }
        ,isProductWrapper: function(item) {
            return _.isObject(item) && _.hasAny(item, ['product_id', 'product']);
        }
        ,isRecipeWrapper: function(item) {
            return _.isObject(item) && _.hasAny(item, ['recipe_id', 'recipe']);
        }
        ,getDropshipfulfillmentType: function(item, mapFulfillmentType) {
            if(item && item.fulfillment_type_ids) {
                if(!mapFulfillmentType) mapFulfillmentType = this.map.get('fulfillmentType');
                var dropShip = mapFulfillmentType.get('drop_ship');
                if(dropShip.id && _.contains(item.fulfillment_type_ids, dropShip.id)) {
                    return dropShip;
                }
            }
        }
        ,getProductFulfillmentType: function(item) {
            //if there is only one fulfillment type supported on product
            //but more than one fulfillment type supported on store we will display a indicator
            var fulfillmentTypes = this.map.get('storeFulfillmentType');
            if(_.size(item.fulfillment_type_ids) == 1 && fulfillmentTypes.items().length > 1) {
                var fulfillmentType = fulfillmentTypes.get(item.fulfillment_type_ids[0]);
                if(fulfillmentType.id) return fulfillmentType;
            }
        }

        ,isProductAd: function(item) {
            return _.isObject(item) && _.has(item, 'product_id') && _.hasAny(item, ['interaction_track_url', 'product_on_load_beacon', 'product_on_view_beacon']);
        }
        ,isBannerAd: function(item) {
            return _.isObject(item) && _.hasAny(item, ['interaction_track_url', 'product_on_load_beacon', 'product_on_view_beacon']);
        }
        ,getProduct: function(item, defaultValue) {
            var product;
            if(this.isProductWrapper(item)) product = item.product;
            else if(this.isProduct(item)) product = item;

            return _.getObject(product, defaultValue);
        }
        ,getRecipe: function(item, defaultValue) {
            var recipe;
            if(this.isRecipeWrapper(item)) recipe = item.recipe;
            else recipe = item;

            return _.getObject(recipe, defaultValue);
        }
        ,isUploadImage: function(item) {
            return _.isObject(item) ? (!_.has(item, 'identifier') || S(item.identifier).startsWith(fpConstants.NEW_ITEM_PREFIX, true)) && _.has(item, 'source_url') : false;
        }
        ,getItemId: function(id) {
            id = _.first(S.getString(id).match(this.regExp.matchItemId));
            if(id === 'null' || id === 'undefined') id = null;
            return id;
        }
        ,getEventNs: function(event) {
            if(!_.isObject(event)) return '';
            return event.type + (event.namespace ? '.' + event.namespace : '');
        }
        ,getSequenceValue: function(value, delimiter) {
            delimiter = delimiter || '';
            var returnValue = '';

            if(_.isArray(value)) {
                var array = [];
                for(var n=0;n<value.length;n++) {
                    if(value[n]) {
                        var item = $.trim(this.getSequenceValue(value[n]));
                        if(item) array.push(item);
                    }
                }
                returnValue = array.join(delimiter);
            }
            else if(_.isObject(value)){
                if(!this.isSequenceObject(value)) return returnValue;
                if(_.has(value, 'identifier')) returnValue = S.getString(value.identifier);
                else {
                    for (var key in value) {
                        if (key != 'sequence' && key != 'id') {
                            returnValue = S.getString(value[key]);
                            break;
                        }
                    }
                }
            }
            else returnValue = S.getString(value);

            return returnValue;
        }
        ,getUom: function(item, key, separator) {
            separator = separator || '';
            var uomValue = '',
                size = item[key + '_per_serving'];
            if(size) {
                var uom = item[key + '_uom'];
                if(this.isNumeric(size)) size = parseFloat(size.toString());
                uomValue += size;
                if(uom) uomValue += separator + uom;
            }
            return uomValue;
        }
        ,getPriceSizeComboHtml: function(item, intent) {
            if(fp.isBot) return '';
            if(fp.productConfigurationConfig.show_pricing_only_if_user_logged_in && !fpUtil.isAuthenticated()) return '';
            intent = intent || fpConfig.intent;

            var html = '',
                product,
                price,
                salePrice,
                size;

            //use fields from wrapper object if intent = 'admin' or intent = 'order'
            if(item.order_id || item.receipt_id || _.contains(['admin', 'order'], intent)) product = item;
            else product = this.getProduct(item);

            if(intent != 'admin') {
                var storePriceMode = this.map.get('storePriceMode');

                if (!storePriceMode.get('select_price_required_store').id) {
                    return html;
                }

                var selectedStorePriceMode = S(storePriceMode.get(fp.store.price_mode_id).identifier);

                if (selectedStorePriceMode.eq('dont_show_price')) return html;

                if (selectedStorePriceMode.eq('select_price_required_store')) {
                    const nextUrl = fp.ui.router.stateManager.href(fpConfig.routeStates.productDetail, {id: product.id}, {canonical_url: product.canonical_url}),
                        selectStoreLabel = fp.ui.localef('shared-select-store-see-price', 'Click to select a store to see the price for {0}', product.name),
                        seePrice = fp.ui.locale('shared-see-price', 'See Price'),
                        seePriceLabel = S.getString(fpConfig.seePriceLabel, seePrice);
                        
                    if(fp.config.enableSeePriceModal) {
                        html = this.formatString(
                            `<a href="{0}" aria-label="${selectStoreLabel}" class="fp-price-link fp-btn-link" data-action="see-price-modal">{1}</a>`,
                            nextUrl,
                            seePriceLabel
                        );
                    }
                    else {
                        html = this.formatString(
                            `<a href="{0}" aria-label="${selectStoreLabel}" class="fp-price-link fp-btn-link">{1}</a>`,
                            fp.ui.router.stateManager.href(fpConfig.routeStates.storeLocator, {next: nextUrl, intent: 'price'}),
                            seePriceLabel
                        );
                    }
                    return html;
                }
            }

            price = item.price || product.price;
            salePrice = item.sale_price || product.sale_price;
            size = item.size || product.size;

            if(price && price != salePrice) {
                if(salePrice) html += '<span class="sr-only">' + fpUi.locale('shared-original-price-label', 'Original price:') + '</span>';
                html += '<span class="fp-item-base-price">' + this.encodeForHtml(price) + '</span>';
            }
            if (size) {
                if (html) html += '<span class="fp-divider">' + fpConfig.weightDivider + '</span>';
                html += '<span class="fp-item-size">' + this.encodeForHtml(size) + '</span>';
            }

            return html;
        }
        ,getPriceSizeCombo: function(item) {
            var html = '',
                price = item.fulfilled_price || item.price;

            if(price) html += '<span class="item-price' + (item.sale_price ? ' has-sale-price' : '') + (item.size && item.size.length > 10 ? ' has-item-size-lg' : '') + '">' + price + '</span>';

            if(item.size) {
                if(html) html += '<span class="divider"> | </span>';
                html += '<span class="item-size">' + item.size + '</span>';
            }
            return html;
        }
        ,getSalePriceSizeComboHtml: function(item, intent) {
            if(fp.isBot) return '';
            if(
                fp.productConfigurationConfig.show_pricing_only_if_user_logged_in &&
                !fpUtil.isAuthenticated()
            ) {
                return '';
            }

            intent = intent || fpConfig.intent;

            var product,
                salePrice;

            //use fields from wrapper object if item is an order item
            if(item.order_id || item.receipt_id) product = item;
            else product = this.getProduct(item);

            var enableSaleDateMd = fpConfig.enableSaleDateMd && product.sale_price_md;
            if(enableSaleDateMd) {
                salePrice = fp.markdownConverter.makeHtml(product.sale_price_md).replace(/<\/?p>/gim, '')
            }
            else salePrice = this.encodeForHtml(item.sale_price || product.sale_price);
            
            if(!salePrice) return '';

            if(intent != 'admin') {
                var storePriceMode = this.map.get('storePriceMode');
                if (
                    !storePriceMode.get('select_price_required_store').id ||
                    fp.store.price_mode_id == storePriceMode.get('dont_show_price').id ||
                    fp.store.price_mode_id == storePriceMode.get('select_price_required_store').id
                ){
                    return '';
                }
            }

            var html = '<span class="fp-item-sale-price"><span class="sr-only">' + fpUi.locale('shared-sale-price-label', 'Sale price:') + '</span>' + salePrice + S.getString(fpConfig.storeCard.productSaleLabelHtml) + '</span>',
                saleStartDate = item.sale_start_date || item.start_date,
                saleFinishDate = item.sale_finish_date || item.finish_date;

            if (saleStartDate && saleFinishDate) {
                saleStartDate = this.formatDate(saleStartDate, fpConfig.saleDateFormat);
                saleFinishDate = this.formatDate(saleFinishDate, fpConfig.saleDateFormat);

                if(enableSaleDateMd) html = '<span class="fp-item-sale-date"><span class="sr-only">' + fpUi.locale('shared-sale-price-label', 'Sale price:') + '</span>' + salePrice + '</span>';
                else if(!fpConfig.saleDateThroughLabel) html += ' <span class="fp-item-sale-date">(' + this.encodeForHtml(saleStartDate) + '&ndash;' + this.encodeForHtml(saleFinishDate) + ')</span>';
                else html += ' <span class="fp-item-sale fp-item-sale-date">(' + fpConfig.saleDateThroughLabel + ' ' + this.encodeForHtml(saleFinishDate) + ')</span>';
            }

            return html;
        }
        ,getSalePriceSizeCombo: function(item, intent, dateLabel, disableWrapHtml) {
            intent = intent || fpConfig.intent;

            var value = {
                    price: '',
                    date: ''
                },
                product,
                salePrice;

            if(fp.isBot) return value;

            //use fields from wrapper object if intent = 'admin' or intent = 'order'
            if(item.order_id || item.receipt_id || intent == 'admin') product = item;
            else product = this.getProduct(item);

            var enableSaleDateMd = fpConfig.enableSaleDateMd && product.sale_price_md;
            if(enableSaleDateMd) {
                salePrice = fp.markdownConverter.makeHtml(product.sale_price_md).replace(/<\/?p>/gim, '')
            }
            else salePrice = this.encodeForHtml(item.sale_price || product.sale_price);
            
            if(!salePrice) return value;

            if(intent != 'admin') {
                var storePriceMode = this.map.get('storePriceMode');
                if (
                    !storePriceMode.get('select_price_required_store').id ||
                    fp.store.price_mode_id == storePriceMode.get('dont_show_price').id ||
                    fp.store.price_mode_id == storePriceMode.get('select_price_required_store').id
                ){
                    return value;
                }
            }

            value.price = salePrice + S.getString(fpConfig.storeCard.productSaleLabelHtml)
            if(!disableWrapHtml) value.price = '<span class="fp-item-sale-price">' + value.price + '</span>';
            var saleStartDate = item.sale_start_date || item.start_date,
                saleFinishDate = item.sale_finish_date || item.finish_date;

            if (saleStartDate && saleFinishDate) {
                saleStartDate = this.formatDate(saleStartDate, fpConfig.saleDateFormat);
                saleFinishDate = this.formatDate(saleFinishDate, fpConfig.saleDateFormat);

                value.date = S.getString(dateLabel);
                
                if(enableSaleDateMd) {
                    value.price = salePrice;
                    if(!disableWrapHtml) value.price = '<span class="fp-item-sale-date">' + salePrice + '</span>';
                }
                else {
                    var date = '';
                    if(!fpConfig.saleDateThroughLabel) date = this.encodeForHtml(saleStartDate) + '&ndash;' + this.encodeForHtml(saleFinishDate);
                    else date = fpConfig.saleDateThroughLabel + ' ' + this.encodeForHtml(saleFinishDate);
                    if(!disableWrapHtml) date = '<span class="fp-item-sale-date">(' + date + ')</span>';
                    value.date += date;
                }
            }

            return value;
        }
        ,getClippableOfferSalePriceComboHtml: function(item) {
            if(fp.isBot) return '';

            var salePrice = item.sale_price;
            if(!salePrice) return '';

            var html = '<span class="fp-item-sale fp-item-sale-price">' + this.encodeForHtml(salePrice) + '</span>',
                saleStartDate = item.start_date,
                saleFinishDate = item.finish_date;

            if (saleStartDate && saleFinishDate) {
                saleStartDate = this.formatDate(saleStartDate, fpConfig.saleDateFormat);
                saleFinishDate = this.formatDate(saleFinishDate, fpConfig.saleDateFormat);

                if(fpConfig.enableSaleDateMd && item.sale_price_md) {
                    html = '<span class="fp-item-sale-date">' + fp.markdownConverter.makeHtml(item.sale_price_md).replace(/<\/?p>/gim, '') + '</span>';
                }
                else if(!fpConfig.saleDateThroughLabel) html += ' <span class="fp-item-sale-date">(' + this.encodeForHtml(saleStartDate) + '&ndash;' + this.encodeForHtml(saleFinishDate) + ')</span>';
                else html += ' <span class="fp-item-sale fp-item-sale-date">(' + fpConfig.saleDateThroughLabel + ' ' + this.encodeForHtml(saleFinishDate) + ')</span>';
            }

            return html;
        }
        ,getAdminImageSrc: function(item, imageConfig, size) {
            //console.log(item, imageConfig, size);
            size = size || 'medium';
            imageConfig = imageConfig || $rootScope.store.image_config || {};
            var src
                ,isProduct = this.isProduct(item)
                ,isUploadImage = this.isUploadImage(item);

            if(_.isObject(item)) {
                if(isProduct) src = this.getSequenceValue(item.cover_image);
                else if(item.identifier) src = item.identifier;
                else if(item.source_url) src = item.source_url;
                else src = this.getSequenceValue(item);
            }
            else src = item;

            //console.log(src);

            if(isProduct && !src) src = this.genericImageUrl;
            if(src) {
                if(!isUploadImage) {
                    if (imageConfig.prefix && !src.startsWith('http', true)) src = imageConfig.prefix + src;
                    if (imageConfig.suffixes) src += imageConfig.suffixes[size];
                }
            }
            else src = this.blankImageUrl;

            return src;
        }
        ,getImageSrc: function(item, size, imageConfig, type, options) {
            // fp.log(item, size, imageConfig, type);

            var isProduct = type == 'product',
                isRecipe = type == 'recipe',
                src;

            if(_.isObject(item)) {
                if(!isRecipe) {
                    item = this.getProduct(item, item);
                    isProduct = this.isProduct(item);
                }
                if(isRecipe || !isProduct) {
                    item = this.getRecipe(item, item);
                    if(!isRecipe) isRecipe = this.isRecipe(item);
                }

                if(_.isObject(item.cover_image)) item = item.cover_image;

                src = item.cover_image || item.identifier || item.source_url;

                if(S(src).startsWith(fpConstants.NEW_ITEM_PREFIX, true)) {
                    src = item.source_url;
                }
            }
            else src = item;

            //fp.log('******************')
            //fp.log('isRecipe', isRecipe);
            //fp.log('isProduct', isProduct);
            //fp.log('src', src);
            //fp.log('item', item);

            if(!src && (isProduct || isRecipe)) {
                if(isRecipe) {
                    src = fpConfig.genericRecipeImageUrl;
                    type = 'recipe';
                }
                else {
                    src = fpConfig.genericProductImageUrl;
                    type = 'product';
                }
            }

            if(src && !this.isUploadImage(item)) {
                src = fpUi.getAssetCdnUrl(src, _.defaults(options, {
                    size: size,
                    imageConfig: imageConfig,
                    type: type
                }));
            }
            else if(!src) src = fp.blankImageUrl;

            //fp.log(item, imageConfig, size, src);
            return src;
        }
        ,getItemButtonHtml: function(item, quantity) {
            if (!_.isObject(item)) return '';
            
            quantity = quantity != null ? quantity : fp.ui.ListManager.getItemQuantity(item);

            if (!quantity) return '';
            
            var inListLabel = fpConfig.inListLabel ? fpConfig.inListLabel : '',
                quantityProperty = 'quantity_label';
            if (quantity == 1) quantityProperty += '_singular';

            var quantityLabel = S.getString(this.getProduct(item)[quantityProperty]);
            if (quantityLabel) {
                return this.formatString('{0} <span class="fp-item-quantity-label">{1}</span>', quantity, this.encodeForHtml(quantityLabel));
            }

            return quantity + inListLabel;
        }
        ,getItemQuantityLabel: function(item, quantity, disableQuantity) {
            if (!_.isObject(item)) return '';
            
            if(this.isNull(quantity) && this.isOrderItem(item) && this.map.get('orderItemStatus', null, true).get(item.status_id).identifier == 'added_by_store') {
                quantity = item.fulfilled_quantity;
            }

            quantity = quantity != null ? quantity : fp.ui.ListManager.getItemQuantity(item);

            var quantityProperty = 'quantity_label';

            if (quantity == 1) quantityProperty += '_singular';

            var quantityLabel = S.getString(this.getProduct(item)[quantityProperty]);

            if (!quantity) return '';

            if (quantityLabel) quantityLabel = ' ' + quantityLabel;

            return disableQuantity ? quantityLabel.trim() : quantity + quantityLabel;
        }
        ,getItemFulfillQuantityLabel: function(item) {
            if (!_.isObject(item)) return '';
            const constants = fp.constants;
            var quantity
                ,quantityToFulfill
                ,quantityString
                ,quantityLabel;

            if(item.status_id == constants.orderItemStatusId.ADDED_BY_STORE) {
                quantity = quantityToFulfill = item.fulfilled_quantity;

                if (!quantity) return '';

                quantityString = parseFloat(quantity).toString();
            }
            else {
                quantityToFulfill = item.quantity_to_fulfill;
                quantity = item.quantity;
                // var itemSize =  item.size ? ' (' + item.size + ')' : '';

                if (!quantityToFulfill) return '';

                // quantityString = parseFloat(quantityToFulfill).toString() + itemSize;
                quantityString = parseFloat(quantityToFulfill).toString();
            }
            quantityLabel = quantity == 1 && item.quantity_label_singular ? item.quantity_label_singular : item.quantity_label;

            if(item.status_id == constants.orderItemStatusId.ADDED_BY_STORE) {
                // if(item.size) quantityLabel = quantityLabel || '(' + item.size + ')';
                quantityString = quantityString + (quantityLabel ? ' ' + quantityLabel : '');
            }
            else if(quantityLabel) {
                // quantityString += '<br/>(' + quantity + ' ' + quantityLabel + ')';
                quantityString = quantity + ' ' + quantityLabel;
            }

            if(quantityToFulfill && item.size) {
                if(!quantityString) quantityString = quantityToFulfill + ' ' + item.size;
                else if(item.quantity_size_ratio) quantityString = quantityToFulfill + ' ' + item.size + '<br/>' + '(' + quantityString + ')';
            }
            // if(item.id== '1275518880063686497') console.log(item, quantityToFulfill, item.quantity, quantityLabel, quantityString);
            return quantityString;
        }
        ,getItemHasSaleModifier: function(item) {
            var product = this.getProduct(item),
                hasModifier;

            if(product.sale_configuration_type_id) {
                var saleConfigurationType = this.map.get('saleConfigurationType').get(product.sale_configuration_type_id);
                hasModifier = saleConfigurationType.id && _.contains([
                        'buy_x_get_x_free',
                        'buy_x_get_x_fixed_price',
                        'price_off',
                        'price_off_total',
                        'percentage_off'
                    ], saleConfigurationType.identifier);
            }

            return this.getBoolean(hasModifier);
        }
        ,getItemHasOfferTag: function(item) {
            return _.find(this.getProduct(item).offers, function(item) {
                return _.size(item.tags) > 0
            }) != null;
        }
        ,getPriceDisclaimer: function(item) {
            var product = this.getProduct(item),
                disclaimer = product.sale_price_disclaimer;

            if(product.price_disclaimer) {
                if(disclaimer) {
                    disclaimer = S(disclaimer)
                        .ensureRight('. ')
                        .concat(product.price_disclaimer).s;
                }
                else disclaimer = product.price_disclaimer;
            }

            return S.getString(disclaimer);
        }
        ,getPromoText: function(item) {
            if(!item) return;

            var config,
                promoText;

            if(item.promotion_text) promoText = item.promotion_text;
            else {
                config =  this.getValueFromNamespace('config', item);
                if(config) promoText = config.promotion_text;
            }            

            return S.getString(promoText);
        }
        ,setActiveDepartments: function(deptHash, enableReset) {
            var activeDeptId = fp.department.id || fpUi.router.routeManager.urlParams.department_id;
            deptHash = _.getObject(deptHash, fp.departmentHash);

            if(enableReset) {
                for (var key in deptHash) {
                    delete deptHash[key].active;
                }
            }

            var item = _.getObject(deptHash[activeDeptId], fp.department);
            if(_.size(item)) {
                while (item) {
                    item.active = true;
                    item = deptHash[item.parent_id];
                }
            }
            //var clientCache = fp.client.cache;
            //if(deptHash != clientCache.menuItemHash) this.setActiveDepartments(clientCache.menuItemHash, activeDept.id);
        }
        //assumes points string of format points: "100,100 200,100 200,200 100,100"
        //data read in clockwise fashion
        ,pointsToRect: function(points, scale){
            scale = scale || 1;

            var rect = {
                    x:null,
                    y:null,
                    width:null,
                    height:null
                },
                point,
                x1,
                x2,
                y1,
                y2;

            points = fp.S.getString(points).split(' ').slice(0, 4);

            if(points.length == 4) {
                point = points[0].split(',');
                x1 = parseFloat(point[0]);
                y1 = parseFloat(point[1]);

                point = points[2].split(',');
                x2 = parseFloat(point[0]);
                y2 = parseFloat(point[1]);
                rect.x = x1 * scale;
                rect.y = y1 * scale;
                rect.width = Math.abs(x2 - x1) * scale;
                rect.height = Math.abs(y2 - y1) * scale;
            }

            return rect;
        }
        ,showProgress: function(/* [inc], ..., hidePromise */) {
            var args = _.toArray(arguments),
                inc;

            if(!this.isPromise(args[0])) {
                inc = args.shift();
            }

            //fp.log('NProgress.status', NProgress.status);
            // fp.log('showProgress', inc, showProgressTimeout, args.length, args);
            // fp.logStack('showProgress');

            if(!showProgressTimeout) {
                // fp.log('NProgress.status', NProgress.status)

                function showProgress() {
                    if(!fp.documentReady) return;

                    if (_.isUndefined(showProgressTimeout)) {
                        NProgress.configure({
                            showSpinner: false,
                            parent: 'body > .fp-freshop'
                            /*, trickle: false*//*, positionUsing: 'margin'*/
                        });
                    }

                    showProgressTimeout = 0;

                    //passing in undefined will call increment behind the scenes
                    //NProgress will call start if not already started
                    inc = NProgress.status ? fpUtil.getFloat(inc, 0.05) : 0;
                    NProgress.inc(inc);
                }

                var startDelay = fp.loaded ? fpConstants.progress.DELAY : 0;
                if(startDelay) showProgressTimeout = setTimeout(showProgress, startDelay);
                else showProgress();
            }

            if(this.isPromise(args[0])) {
                this.hideProgress.apply(this, args);
            }
        }
        ,hideProgress: function(/* [force], ..., hidePromise */) {
            if(fp.isUnloading) return $.when();

            var force = false,
                promise;

            if(!this.isPromise(arguments[0])) force = arguments[0];

            //fp.log('hideProgress', NProgress.status, NProgress, force, fp.loaded);

            //if(!NProgress.status || (!force && !fp.loaded)) {
            //    return $.when();
            //}

            if(force) {
                // fp.log('hideProgress', force, hideProgressPromises.length, hideProgressPromises);
                hideProgressForce = true;
                clearTimeout(showProgressTimeout);
                showProgressTimeout = 0;
                hideProgressPromises.length = 0;
            }
            else {
                var args = _.toArray(arguments);
                if(!this.isPromise(args[0])) args.shift();

                if(args.length) {
                    promise = $.when.apply($, args).promise();
                    hideProgressPromises.push(promise);
                }
            }

            return $.when.apply($, hideProgressPromises)
                .always(function() {
                    if(promise) _.remove(hideProgressPromises, promise);
                    // fp.log('hideProgress', fp.loaded, hideProgressPromises.length);
                    if(!force && !hideProgressForce && (hideProgressPromises.length || !fp.loaded)) {
                        return;
                    }

                    // fp.log('NProgress.done');
                    clearTimeout(showProgressTimeout);
                    showProgressTimeout = 0;

                    if(force || fp.documentReady) NProgress.done();
                });
        }
        ,initCustomLoader: function() {
            if(fp.customLoader) return;

            fp.customLoader = new fp.ui.Loading({enableEvents: true});

            if (fp.loader && fp.loader.isShown()) {
                if(!$('[data-role="loading-indicator"]').length) return;

                fp.customLoader.__showCount = fp.loader.__showCount - 1;
                fp.loader.hide(true);

                this.showLoading();
            }
        }
        ,showLoading: function(startDelay) {
            if(!fp.documentReady) return;

            var loader = fp.customLoader || fp.loader;
            if(!loader) return;

            if(this.isNull(startDelay)) startDelay = fp.loaded ? fpConstants.progress.DELAY : 0;

            var loaderOptions = {startDelay: startDelay};

            if(loader == fp.customLoader) {
                loaderOptions.appendTo = $('[data-role="loading-indicator"]');
                if (!loaderOptions.appendTo.length) loader = fp.loader;
            }

            if(!loader) return;
            loader.show(loaderOptions);
        }
        ,hideLoading: function(force) {
            if(
                !fp.documentReady ||
                fp.isUnloading
            ) {
                return;
            }

            var loader = fp.customLoader || fp.loader;
            if(!loader) return;

            loader.hide(force);
        }
        //utility for testing promise
        ,delayPromise: function(promise, delay) {
            if(!this.isPromise(promise)) promise = $.when();
            if(fp.isProd()) return promise;
            delay = this.getInteger(delay, 2000);

            return promise
                .then(function() {
                    var args = arguments,
                        deferred = $.Deferred();

                    _.delay(function() {
                        deferred.resolve.apply(deferred, args);
                    }, delay);

                    return deferred.promise();
                });
        }
        ,getRejectedPromise: function(args) {
            var deferred = $.Deferred();
            return deferred.reject.apply(deferred, _.toArray(args)).promise();
        }
        ,getPromiseFromEvent: function(eventName) {
            var deferred = $.Deferred();
            fp.one(eventName, deferred.resolve);
            return deferred.promise();
        }
        ,setFocus: function($element, priority) {
            if(fpConfig.disableSmartScrollResults && !fp.device.xs) return;

            //fp.logStack('setFocus')
            $element = $($element);
            var cachedFocus = this.getNamespace('focus', fp.cache);

            if($element.hasClass('fp-module')) {
                var $this,
                    $input,
                    nextPriority,
                    prevPriority;

                $element.find('input[fp-autofocus]:visible').each(function () {
                    $this = $(this);
                    if($this.closest('.fp-module').attr('fp-autofocus') == 'false') {
                        return false;
                    }

                    nextPriority = fpUtil.getInteger($this.attr('fp-autofocus'), fpConstants.priority.MINOR);
                    if (fpUtil.isNull(prevPriority) || nextPriority < prevPriority) {
                        $input = $this;
                        priority = nextPriority;
                    }
                    prevPriority = nextPriority;
                });

                if(!$input) {
                    $element.find('input[type="text"]:visible, input[type="search"]:visible').each(function() {
                        $this = $(this);
                        if($this.closest('.fp-module').attr('fp-autofocus') == 'false') {
                            return false;
                        }

                        $this = $this.parent();
                        if(!($this.hasClass('input-group date') || $this.hasClass('select2-search'))) {
                            $input = this;
                            return false;
                        }
                    });
                }

                $element = $($input);
            }
            else {
                $element = $element.filter('input[fp-autofocus]:visible');
            }

            if($element.length) {
                priority = this.getInteger(priority, fpConstants.priority.MINOR);
                if (
                    priority < cachedFocus.priority
                    || !cachedFocus.$element
                    || !(cachedFocus.$element && cachedFocus.$element.filter(':visible').length)
                ) {
                    cachedFocus.priority = priority;
                    cachedFocus.$element = $element;
                }
            }

            if(!fp.loaded) return;

            if(cachedFocus.$element && (fpUtil.isNull(priority) || cachedFocus.priority < priority)) {
                $element = cachedFocus.$element;
            }
            _.empty(cachedFocus);

            //if($element && $element.length) {
            //    fp.log('setFocus', $element[0]);
            //    //fp.logStack('setFocus')
            //}
            if($element.length) {
                $element.trigger('focus');
            }
        }
        ,validateForm: function(form, $error, altFormName, options) {
            options = $.extend({
                includeDisplayNone: true
            }, options);

            var self = this,
                $form = $(form),
                altFormName = S.getString(altFormName || $form.attr('data-alt-name')),
                formGroup = S.getString(options.formGroup || $form.attr('data-form-group')),
                inputFormGroup = '',
                validationGroups = {},
                errors = [],
                invalidInputs = [],
                inputName,
                $input,
                validationGroup,
                errorMsg,
                isValid,
                selector;

            if(!($error && $error.length) && _.has(options, 'errorSelector')) {
                $error = $(options.errorSelector);
            }
            if(!($error && $error.length)) $error = fp.ui.getFormError($form, options.formGroup);
            $error = $error.hide().first();

            if(altFormName) {
                selector = this.formatString('input[data-form-name="{0}"],textarea[data-form-name="{0}"],select[data-form-name="{0}"]', altFormName);
            }
            else selector = 'input,textarea,select';

            $form.find(selector).each(function() {
                $input = $(this);
                if($input.prop('disabled')) return;
                if(!options.includeDisplayNone && S.getString(this.type).toLowerCase() !== 'hidden' && !$input.filter(':visible').length) return;

                var type = S($input.prop('type'));
                if(type.eq('button', true) || type.eq('submit', true)) return;

                if(!options.disableInputFormGroup) {
                    inputFormGroup = S.getString($input.attr('data-form-group'));
                    if (inputFormGroup != formGroup && inputFormGroup != '*') return;
                }

                inputName = $input.attr('name');
                if(inputName) {
                    validationGroup = validationGroups[inputFormGroup] || (validationGroups[inputFormGroup] = {});
                    $input.removeAttr('aria-describedby');
                }

                if(!inputName || !validationGroup[inputName]) {
                    if(inputName) validationGroup[inputName] = true;
                    errorMsg = self.validateInput($input, options.validate);
                    if(fpConfig.enableEnhancedValidation) $input.toggleClass('is-invalid', !!errorMsg);
                    if(errorMsg) {
                        errors.push(errorMsg);
                        invalidInputs.push($input);
                    }
                }
            });

            isValid = (errors.length == 0);
            if(_.isFunction(options.onValidate)) {
                errorMsg = options.onValidate(isValid, $form);
                if(errorMsg) errors.push(errorMsg);
            }

            isValid = (errors.length == 0);

            if(!isValid && !options.disableShowError) {
                this.showError(errors, $error, {
                    enableAlertModal: options.enableAlertModal,
                    disableFocus: true
                });

                // add aria-describedby to each invalid input
                invalidInputs.forEach(function($input) {
                    $input.attr('aria-describedby', fp.S.getString($error.prop('id')));
                });

                // focus on invalid input
                // if inside fp-dropdown, focus on fp-dropdown-value instead
                if(invalidInputs[0].parent().hasClass('fp-dropdown')) {
                    invalidInputs[0].parent().find('.fp-dropdown-value').trigger('focus');
                } else {
                    invalidInputs[0].trigger('focus');
                }

                if(_.isFunction(options.showError)) options.showError(errors, $error);
            }

            options.errors = errors;

            return isValid;
        }
        ,validateInput: function($input, options) {
            var validationRules = fp.ui.validation.rules,
                validate = S.getString($input.attr('fp-validate')),
                hashedValidate = this.attrParams(validate),
                arrayValidate = validate.split(','),
                label = $input.attr('fp-error-label') || $input.attr('placeholder') || $input.prev().text(),
                name = $input.attr('name'),
                value = fp.ui.getInputValue($input),
                rawValue = S($input.val()).trim(),
                rule,
                ruleMessage,
                validateSetting,
                match,
                valid,
                key,
                error;

            if(!_.has(hashedValidate, 'xss') && !S(name).contains('password', true) && S($input.prop('nodeName')).ne('textarea', true)) {
                hashedValidate.xss = true;
            }

            validateLoop:
            for(var n=0;n<arrayValidate.length;n++) {
                key = arrayValidate[n].split('=')[0];
                validateSetting = hashedValidate[key];
                valid = true;

                if(key == 'custom') {
                    var onValidate;
                    if(validateSetting && options) {
                        onValidate = options[validateSetting];
                    }

                    if (_.isFunction(onValidate)) {
                        error = onValidate(value, $input);
                        if (error) break;
                    }
                    else console.warn(this.formatString('Validation custom not found: {0}.', S.getString(validateSetting)));
                }
                else {
                    rule = validationRules[key];

                    if(rule) {
                        ruleMessage = $input.attr('fp-error-message');
                        if(!ruleMessage) ruleMessage = _.result(rule, 'message');
                        label = $input.attr('fp-error-label') || $input.attr('placeholder') || $input.prev().text();

                        if(_.isRegExp(rule.match)) {
                            if(value) {
                                match = rule.match.test(value);
                                if (this.getBoolean(rule.negate, false)) match = !match;
                                if (!match) {
                                    error = this.formatString(ruleMessage, label);
                                    break;
                                }
                            }
                        }
                        else {
                            switch(key) {
                                case 'required':
                                    if(!value) {
                                        var linkedInput = $input.attr('fp-validate-linked-input');
                                        var customInput = $input[0].getAttribute('data-value');
                                        if(linkedInput) {
                                            var $linkedInput = $($input[0].form).find(linkedInput).first();
                                            if($linkedInput.length) {
                                                value = fp.ui.getInputValue($linkedInput);
                                                if(value) continue;

                                                label += ' or ' + ($linkedInput.attr('fp-error-label') || $linkedInput.attr('placeholder') || $linkedInput.prev().text());
                                            }
                                        }else if(customInput && label === '') {
                                            if ($input && $input[0].name && $input[0].name.indexOf('-') != -1) {
                                                var inputName = $input[0].name.split('-');
                                                    if (inputName[2].indexOf('-')!=-1) {
                                                        label = inputName[2].replaceAll('_', ' ');
                                                    }
                                            }   
                                        }

                                        error = this.formatString(ruleMessage, label);
                                        break validateLoop;
                                    }
                                    break;
                                case 'min-length':
                                    if(_.isString(value) && value.length) {
                                        var minLength = this.getInteger(validateSetting);
                                        if (value.length < minLength) {
                                            error = this.formatString(ruleMessage, label, minLength);
                                            break validateLoop;
                                        }
                                    }
                                    break;
                                case 'credit-card':
                                    var cardTypes;
                                    //var cardTypes = ['visa', 'mastercard', 'amex', 'discover'];
                                    if(!$.payment.validateCardNumber($input.val(), cardTypes).valid) {
                                        error = this.formatString(ruleMessage, label);
                                        break validateLoop;
                                    }
                                    break;
                                case 'min-date':
                                    if(value) {
                                        var minDate = validateSetting,
                                            minDateLowered = S(validateSetting).toLowerCase(),
                                            inputDate = dateFns.startOfDay(dateFns.parse(value));

                                        if (minDateLowered.startsWith('endof')) {
                                            minDate = dateFns.endOfDay(dateFns.parse(minDateLowered.trimLeft('endof').s));
                                        }
                                        else {
                                            if (minDateLowered.startsWith('startof')) {
                                                minDate = dateFns.startOfDay(dateFns.parse(minDateLowered.trimLeft('startof').s));
                                            }
                                            else if (_.contains(['now', 'current', 'today'], minDateLowered.s)) {
                                                minDate = dateFns.startOfDay(new Date());
                                            }
                                            else minDate = dateFns.startOfDay(dateFns.parse(minDate));
                                        }

                                        //fp.log(minDateLowered, inputDate, minDate);
                                        if (inputDate < minDate) {
                                            error = this.formatString(ruleMessage, label);
                                            break validateLoop;
                                        }
                                    }
                                    break;
                                case 'compare':
                                    if(!rawValue.length) {
                                        break validateLoop;
                                    }

                                    var operator = $input.attr('fp-validate-compare-operator'),
                                        targetName = $input.attr('fp-validate-compare-target-name'),
                                        dataType = $input.attr('fp-validate-compare-data-type');

                                    if (!operator || !targetName) continue;

                                    var $target = $($input[0].form).find('[name="' + targetName  + '"]');
                                    if(!S($target.val()).trim().length) {
                                        break validateLoop;
                                    }

                                    var targetValue = fp.ui.getInputValue($target),
                                        targetLabel = $target.attr('fp-error-label') || $target.attr('placeholder') || $target.prev().text(),
                                        operatorDisplay = operator.replace('-', ' ');

                                    switch (dataType) {
                                        case 'datetime':
                                            var sourceFormat = $input.attr('data-display-format'),
                                                targetFormat = $target.attr('data-display-format'),
                                                sourceTime = fp.moment(value, sourceFormat),
                                                targetTime = fp.moment(targetValue, targetFormat);

                                            switch (operator) {
                                                case 'less-than':
                                                    valid = sourceTime.isBefore(targetTime);
                                                    break;
                                                case 'greater-than':
                                                    valid = sourceTime.isAfter(targetTime);
                                                    break;
                                                case 'equal-to':
                                                    valid = sourceTime.isSame(targetTime);
                                                    break;
                                                case 'greater-or-equal-to':
                                                    valid = sourceTime.isSame(targetTime) || sourceTime.isAfter(targetTime);
                                                    break;
                                                default:
                                                    console.warn('Validation compare operator not handled.');
                                                    break;
                                            }

                                            if (!valid)  {
                                                error = this.formatString(ruleMessage, label, operatorDisplay, targetLabel);
                                                break validateLoop;
                                            }

                                            break;
                                        case 'numeric':
                                            value = this.getFloat(value);
                                            targetValue = this.getFloat(targetValue);

                                            switch (operator) {
                                                case 'less-than':
                                                    valid = (value < targetValue);
                                                    break;
                                                case 'greater-than':
                                                    valid = (value > targetValue);
                                                    break;
                                                case 'equal-to':
                                                    valid = (value === targetValue);
                                                    break;
                                                case 'greater-or-equal-to':
                                                    valid = (value >= targetValue);
                                                    break;
                                                default:
                                                    console.warn('Validation compare operator not handled.');
                                                    break;
                                            }

                                            if (!valid) {
                                                error = this.formatString(ruleMessage, label, operatorDisplay, targetLabel);
                                                break validateLoop;
                                            }

                                            break;
                                        default:
                                            switch (operator) {
                                                case 'equal-to':
                                                    valid = S(value).eq(targetValue);
                                                    break;
                                                default:
                                                    console.warn('Validation compare operator not handled.');
                                                    break;
                                            }

                                            if (!valid) {
                                                error = this.formatString(ruleMessage, label, operatorDisplay, targetLabel);
                                                break validateLoop;
                                            }

                                            break;
                                        // default:
                                        //     // TODO: handle others types, dates, numbers, etc...
                                        //     console.warn('Validation compare data-type not handled.');
                                        //     break;
                                    }

                                    break;
                                //no default
                            }
                        }
                    }
                }
            }

            if(options && options.enableEnhancedValidation) $input.toggleClass('is-invalid', !!error);

            return error;
        }
        ,isApiResponseSuccess: function(status) {
            status = this.getFloat(status);
            return status >= fpConstants.httpStatus.OK && status < fpConstants.httpStatus.BAD_REQUEST;
        }
        ,getApiResponseStatus: function(resp, textStatus, jqXHR, options) {
            jqXHR = _.getObject(jqXHR);
            if (!_.isObject(resp)) resp = util.getXhrErrorResponse(jqXHR);
            options = _.getObject(options);

            var httpStatus = fpConstants.httpStatus,
                status = resp.status_code || jqXHR.status || 0;

            if(!status && (textStatus == 'timeout' || (textStatus == 'error' && options.timeout && jqXHR.durationMs >= options.timeout))) {
                status = httpStatus.GATEWAY_TIMEOUT;
            }

            return status;
        }
        ,handleApiError: function(resp, textStatus, jqXHR, options) {
            if(this.isUnloading || !(_.isObject(resp) && _.isObject(jqXHR))) {
                return;
            }

            if(!fp.documentReady) {
                fp.apiErrorQueue.push({
                    resp: resp,
                    textStatus: textStatus,
                    jqXHR: jqXHR,
                    options: options
                });

                return;
            }

            options = _.getObject(options);

            var handleErrors = this.getBoolean(options.handleErrors, true),
                errorDetails = _.getArray(resp.error_fields),
                httpStatus = fpConstants.httpStatus,
                status = this.getApiResponseStatus(resp, textStatus, jqXHR, options),
                errorHandled = false,
                ignoreErrors = options.ignoreErrors,
                errorSelector = options.errorSelector,
                html = S(),
                errorMessage;


            if(status == 0 && window.navigator.onLine === false) {
                errorMessage = fpUi.locale('shared-poor-connectivity', 'Poor connectivity detected');
            }
            else if(status == httpStatus.GATEWAY_TIMEOUT) {
                errorMessage = fpUi.locale('shared-timeout-occurred', 'Timeout occurred');
            }
            else if(status >= httpStatus.INTERNAL_SERVER_ERROR) {
                errorMessage = fpUi.locale('shared-error-request', 'An error has occurred making your request');
            }
            else if(!errorMessage && !errorDetails.length) {
                errorMessage = resp.error_message || jqXHR.error || fpUi.locale('shared-error-occurred', 'An error has occurred');
            }

            if(errorMessage) errorDetails.unshift({error_message: errorMessage});

            //if(status == httpStatus.NOT_FOUND) {
            //    handleErrors = false;
            //    ignoreErrors = [resp.error_code];
            //}

            if(handleErrors && ignoreErrors && resp.error_code) {
                handleErrors = false;
                if (ignoreErrors !== true) {
                    if (!_.isArray(ignoreErrors)) ignoreErrors = [ignoreErrors];
                    handleErrors = !_.contains(ignoreErrors, resp.error_code);
                }
            }

            var matchHtml = this.regExp.matchHtml,
                fragment,
                $input,
                errorLabel;

            function concatErrorDetails(errorDetail, key) {
                if(_.isObject(errorDetail)) {
                    _.each(errorDetail, concatErrorDetails);
                    return;
                }

                errorDetail = S(errorDetail).trim();
                if(!errorDetail.length) return;

                matchHtml.lastIndex = 0;
                if(!matchHtml.test(errorDetail.s)) errorDetail = errorDetail.ensureEnd();

                $input = $('.fp-core [class^="fp-form"]')
                    .find(fpUtil.formatString('[name="fp-input-{0}"],[name="fp-variety-{0}"]', key));

                errorLabel = $input
                    .filter('[fp-error-label]')
                    .first().attr('fp-error-label');

                if(!errorLabel) {
                    if($input.length) {
                        errorLabel = $input.closest('label').find('> .fp-label').text();
                    }
                    if(!errorLabel && !S(key).startsWith('error')) {
                        errorLabel = S(key).humanize().titleCase().s;
                    }
                }

                if(errorLabel) {
                    if(errorDetail.startsWith('is ', true)) {
                        errorDetail = errorDetail.prepend(errorLabel + ': ');
                    }
                    else if(!(key == 'email' && errorDetail.contains('email address'))) {
                        errorDetail = errorDetail.replace(key, errorLabel);
                    }
                }

                fragment = options.markdownToHtml ? errorDetail.s : fpUtil.formatString('<div>{0}</div>', fpUtil.encodeForHtml(errorDetail.s));

                if(!html.contains(fragment, true)) html = html.append(fragment);
            }

            concatErrorDetails(errorDetails);

            if(status && status < httpStatus.INTERNAL_SERVER_ERROR && handleErrors) {
                if(!(fpConfig.enableMobile && !fp.loaded && status == 404)) {
                    errorHandled = this.showError(html.s, errorSelector, {
                        fadeOutMs: options.errorFadeOutMs,
                        encodeForHtml: options.encodeForHtml,
                        markdownToHtml: options.markdownToHtml,
                        status: status
                    }).length > 0;
                }
            }

            if(handleErrors && !errorHandled) {
                if(!errorSelector) errorSelector = 'body > [data-role="freshop-container"] > .fp-request:not(.fp-loading)';

                if(status == 0 && window.navigator.onLine === false) {
                    //when textStatus == 'error' and status == 0 (jQuery >= 3) or status == 404 (jQuery < 3) this may be an indicator of a client connection issue
                    this.showWarning({
                        message: errorMessage,
                        retryMessage: fp.ui.locale('shared-please-try-again', 'Please try again')
                    }, errorSelector);
                }
                else if(status == httpStatus.GATEWAY_TIMEOUT) {
                    this.showWarning({
                        message: errorMessage,
                        retryMessage: fp.ui.locale('shared-please-try-again', 'Please try again')
                    }, errorSelector);
                }
                else {
                    this.showError(errorMessage, errorSelector, {
                        fadeOutMs: options.errorFadeOutMs,
                        encodeForHtml: options.encodeForHtml,
                        markdownToHtml: options.markdownToHtml,
                        status: status
                    });
                }
            }

            return {
                details: errorDetails,
                html: html.s
            };
        }
        ,getApiUrl: function(url, payload, method, isJsonp, addBaseUrl) {
            var apiUrl = url,
                urlParams = payload ? $.param(payload) : '';

            if(isJsonp && S.getString(method, fpConstants.apiMethods.GET) != fpConstants.apiMethods.GET && !S(urlParams).contains('_method=')) {
                urlParams = (urlParams ? urlParams + '&' : '') + '_method=' + method;
            }

            if(urlParams) {
                apiUrl += (S(apiUrl).contains('?') ? '&' : '?') + urlParams;
            }

            if(addBaseUrl) {
                apiUrl = fpUtil.formatString('{0}{1}/{2}', fp.apiBaseUrl, fp.apiVersion, apiUrl);
            }
            return apiUrl;
        }
        ,getMessage: function(message, encodeForHtml, markdownToHtml) {
            encodeForHtml = this.getBoolean(encodeForHtml, true);
            markdownToHtml = this.getBoolean(markdownToHtml, false);
            
            var returnValue = '',
                regExp = this.regExp.matchHtml;

            if(_.isObject(message)) {
                if(message instanceof Error) message = message.message;
                else _.each(message, iterator);
            }
            else iterator(message);

            function iterator(value) {
                value = S(value).trim();
                if(!value.length) return;


                if (encodeForHtml) {
                    value = value
                        .encodeForHtml()
                        .ensureEnd();
                }
                else if(markdownToHtml) {
                    value = value.markdownToHtml();
                }

                regExp.lastIndex = 0;
                if(!regExp.test(value.s)) {
                    returnValue += '<p>' + value.ensureEnd().s + '</p>';
                }
                else returnValue += value.s;
            }

            return returnValue;
        }
        ,showAlert: function(message, $alert, options) {
            //fp.log('showAlert', message, $alert, options);

            if(message instanceof Error) message = message.message;
            
            options = _.getObject(options);
            _.defaults(options, {type: 'warning', handleScroll: true});

            if(!fp.loaded && !options.disableQueue) {
                fp.alertQueue.push({
                    message: message,
                    $alert: $alert,
                    options: options
                });

                return $();
            }

            if(!fp.loaded) {
                this.hideLoading(true);
                this.hideProgress(true);
            }

            switch(options.type) {
                case 'success':
                    message = message || fp.ui.locale('shared-success', 'Success');
                    if(!_.has(options, 'fadeOutMs')) options.fadeOutMs = 10000;
                    break;
                case 'error':
                    message = message || fp.ui.locale('shared-error-request', 'An error has occurred making your request');
                    break;
                default: // warning
                    options.type = 'warning';
                    message = message || fp.ui.locale('shared-warning', 'Warning');
                    break;
            }

            if(!($alert && $alert.length)) {
                var $module,
                    $target;

                if(fp.loaded) {
                    var $this,
                        hasHasViewModule = true,
                        viewModule = fp.Module.getViewModule();

                    $module = viewModule && viewModule.$element.filter(':visible');

                    if(!($module && $module.length)) {
                        hasHasViewModule = false;
                        $module = $('.fp-module');
                    }

                    $module.each(function() {
                        $this = $(this);
                        if(!hasHasViewModule && ($this.css('visibility') == 'hidden' || $this.css('opacity') == '0')) {
                            return;
                        }

                        $target = $this.find(fpUtil.formatString('.fp-notification.fp-{0}', options.type));

                        if ($target.length && hasHasViewModule && $target.closest('.fp-module')[0] != this) {
                            $target = $();
                        }

                        if (!$target.length && !_.size($alert)) {
                            $alert = $this.find('.fp-notification');
                        }
                    });
                }
                else {
                    $module = $('.fp-module[data-role="handle-errors"]');
                    if($module.length) {
                        $target = $module.find(fpUtil.formatString('.fp-notification.fp-{0}', options.type));
                        if(!$target.length && !_.size($alert)) {
                            $target = $module.find('.fp-notification');
                        }
                        if(!$target.length) {
                            $target = $('<div class="fp-notification"></div>').appendTo($module);
                        }
                    }
                }

                if($target && $target.length) $alert = $target;
            }

            $alert = $($alert).first();
            if(!$alert.length) return $alert;

            if(_.contains(['error', 'warning'], options.type)) {
                if($alert.hasClass('fp-request')) {
                    var alert = {
                        retryMessage: fp.ui.locale('shared-click-here', 'Click here to try again')
                    };
                    if(_.isArray(message)) message = _.first(message);
                    if (!_.isObject(message)) alert.message = message;
                    else $.extend(alert, message);

                    $alert
                        .prop('id', this.formatString('fp-alert-{0}', _.uniqueId()))
                        .attr('tabindex', '0')
                        .removeClass('fp-warning fp-error')
                        .addClass('fp-' + options.type)
                        .show()
                        .find('.fp-value').text(alert.message)
                        .end()
                        .find('a').text(alert.retryMessage);

                    $alert
                        .off()
                        .on('click', function (event) {
                            event.preventDefault();
                            event.stopImmediatePropagation();
                            fpUtil.hideError();
                            window.location.reload();
                        });

                    setTimeout(function () {
                        $(document.body)
                            .off('click.error.fp.events')
                            .on('click.error.fp.events', function (event) {
                                fpUtil.hideError();
                            });
                    }, 1);

                    return $alert.focus();
                }

                var $fpRequest = fp.__$freshop.find('> .fp-request:not(.fp-loading):visible').length;
                if($fpRequest.length) return $fpRequest;
            }

            var alertModalOpen;
            if(
                fpConfig.enableAlertModal &&
                options.enableAlertModal !== false &&
                options.type == 'error'
            ) {
                var $activeModal = fpUi.getActiveModal();
                if(!$activeModal.length || $activeModal.attr('data-role') == 'fp-modal-alert') {
                    var self = this,
                        content = fpUtil.formatString(
                            '<div class="fp-icon-notification"></div><div class="fp-notification-message">{0}</div>',
                            fpUtil.getMessage(message, fpUtil.getBoolean(options.encodeForHtml, false), options.markdownToHtml)
                        ),
                        showAlert = function() {
                            self.$alertModal.find('[data-role="alert"]')
                                .removeClass('fp-success fp-warning fp-error hidden')
                                .addClass(fpUtil.formatString('fp-{0}', options.type))
                                .html(content)
                                .css('display', 'block');
                        };

                    if(!this.$alertModal) {
                        this.$alertModal = fp.ui.showModal({
                            name: 'alert',
                            size: 'md',
                            center: true,
                            title: fpUi.locale('shared-alert', 'Alert'),
                            modal: {
                                backdrop: 'static',
                                keyboard: false,
                                show: false,
                                persist: true
                            }
                        });
                    }

                    //need to defer as fp.ui.showModal has defer
                    _.defer(function() {
                        if(!_.getObject(self.$alertModal.data('bs.modal')).isShown) {
                            self.$alertModal
                                .one('show.bs.modal.validateError', showAlert)
                                .modal('show');
                        }
                        else showAlert();
                    });

                    alertModalOpen = true;
                }
            }

            if(!alertModalOpen) {
                if(this.$alert && this.$alert[0] != $alert[0]) {
                    this.$alert.hide();
                    this.$alert = $alert;
                }

                $alert
                    .prop('id', this.formatString('fp-alert-{0}', _.uniqueId()))
                    .attr('tabindex', '')
                    .removeClass('fp-success fp-warning fp-error hidden')
                    .addClass('fp-' + options.type)
                    .html(this.formatString('<div class="fp-icon-notification"></div><div class="fp-notification-message">{0}</div>', this.getMessage(message, this.getBoolean(options.encodeForHtml, false), options.markdownToHtml)))
                    .show();

                if(options.handleScroll) {
                    this.scrollTo($alert, {
                        scrollSelector: options.scrollSelector,
                        callback: function() {
                            if(!options.disableFocus) {
                                $alert
                                    .attr('tabindex', '0')
                                    .focus();
                            }
                            _.getFunction(options.scrollCallback)();
                        }
                    });
                }
                else if(!options.disableFocus) {
                    $alert
                        .attr('tabindex', '0')
                        .focus();
                }

                clearTimeout($alert.data('hideTimeout'));
                $alert.removeData('hideTimeout');

                if(options.fadeOutMs) {
                    hideTimeout = setTimeout(function() {
                        fpUtil.$alert = null;
                        $alert.fadeOut('fast');
                    }, options.fadeOutMs);

                    $alert.data('hideTimeout', hideTimeout);
                }
            }

            return $alert;
        }
        ,hideError: function() {
            $(document.body).off('click.error.fp.events');
            fp.__$freshop.find('> .fp-request:not(.fp-loading)').hide();
        }
        ,showSuccess: function(message, elementSelector, options) {
            options = _.getObject(options);
            options.type = 'success';
            return this.showAlert(message, elementSelector, options);
        }
        ,showWarning: function(message, elementSelector, options) {
            options = _.getObject(options);
            options.type = 'warning';
            return this.showAlert(message, elementSelector, options);
        }
        ,showError: function(message, elementSelector, options) {
            options = _.getObject(options);
            options.type = 'error';
            return this.showAlert(message, elementSelector, options);
        }
        ,scrollTo: function(value, options) {
            //fp.log('scrollTo', value, this.isJQuery(value) && value[0],options);
            if(_.isFunction(options)) options = {callback: options};
            else options = _.getObject(options);

            var top = 0,
                scrollTop = 0,
                $defaultElementToScroll = $('html,body'),
                defaultScrollTop = $('html').scrollTop() || $('body').scrollTop(),
                $elementToScroll = options.scrollSelector && $(options.scrollSelector).first(),
                enableLogicalScroll,
                isScrollingModal,
                height;

            if(value) {
                if(_.isFunction(value)) value = value();

                if(value) {
                    if(_.isObject(value)) {
                        var $element = $(value);
                        if($element && $element.length) {
                            top = $element.offset().top;
                            height = $element.height();
                            enableLogicalScroll = this.getBoolean(options.enableLogicalScroll, true);

                            if(!$elementToScroll) {
                                $elementToScroll = $element.closest('.modal').first();
                                if(!$elementToScroll.length) $elementToScroll = $defaultElementToScroll;
                            }

                            var isScrollingModal = $elementToScroll.hasClass('modal');

                            scrollTop = $elementToScroll.is('body') ? defaultScrollTop : $elementToScroll.scrollTop();

                            if(!isScrollingModal) {
                                $elementToScroll.each(function() {
                                    top -= parseInt($(this).css('marginTop'), 10);
                                });
                            }
                        }
                    }
                    else if(this.isNumeric(value)) top = value;
                }
            }

            if (!$elementToScroll) {
                $elementToScroll = $defaultElementToScroll;
                scrollTop = defaultScrollTop;
            }

            if(enableLogicalScroll) {
                var viewport = $.viewport();

                //fp.log('top', top, 'viewport.top', viewport.top);
                //fp.log('top + height * 0.75', top + height * 0.75, 'viewport.bottom', viewport.bottom);


                if (isScrollingModal) {
                    top += (scrollTop - $elementToScroll.offset().top);
                }
                else if (fpConfig.fixedHeader) {
                    var $fixedHeader = $(fpConfig.fixedHeader);
                    if($fixedHeader.css('position') == 'fixed') top -= $fixedHeader.outerHeight(true);
                }

                //check if 3/4 of element is visible
                 if(top >= viewport.top && top + height * 0.75 <= viewport.bottom) {
                     if(_.isFunction(options.callback)) _.defer(options.callback);
                     return $elementToScroll;
                 }
            }

            // if (!$elementToScroll) {
            //     $elementToScroll = $defaultElementToScroll;
            //     scrollTop = defaultScrollTop;
            // }

            // if(enableLogicalScroll) {
            //     if (isScrollingModal) {
            //         top += (scrollTop - $elementToScroll.offset().top);
            //     }
            //     else if (fpConfig.fixedHeader) {
            //         var $fixedHeader = $(fpConfig.fixedHeader);
            //         if($fixedHeader.css('position') == 'fixed') top -= $fixedHeader.outerHeight(true);
            //     }
            // }

            if (!this.isInteger(options.duration)) {
                options.duration = this.getInteger((scrollTop || 500) / 8);
            }

            //fp.log(top, options, $elementToScroll[0]);

            fp.one(fp.events.LOADED, function() {
                $elementToScroll
                    .animate({
                        scrollTop: top
                    }, {
                        duration: options.duration,
                        easing: 'easeInOutExpo'
                    })
                    .promise()
                    .always(options.callback);
            });

            return $elementToScroll;
        }
        ,getModifiedDate: function(item, format) {
            if(!item) return '';
            format = format || fpConfig.shortDateFormat;

            if(_.isDate(item)) date = item;
            else if(_.isObject(item)) date = item.updated_at || item.last_updated_at || item.created_at;
            else date = item;

            return this.formatDate(date, format);
        }
        ,initDepartment: function(deptId) {
            if(!deptId) {
                var stateParams = fpUi.router.stateManager.stateParams;
                deptId = fpUtil.getItemId(S.getString(stateParams.department_id, fp.moduleDepartmentId));
            }
            deptId = fpUtil.getItemId(deptId);

            var oldDeptId = fp.department.id,
                dept;

            if (deptId) dept = fp.departmentHash[deptId];
            if(dept) fp.department = dept;
            else if(deptId) fp.department = {id: deptId};
            else fp.department = fp.defaultDepartment;

            if (oldDeptId != fp.department.id) {
                fp.log('Department: ', fp.department);
                fpUtil.setActiveDepartments();
                //fp.trigger(fp.events.DEPARTMENT_CHANGED, fp.department);
            }
        }
        ,getNamespace: function(ns, context, readOnly) {
            if(_.isString(ns)) ns = ns.split('.');
            if(!_.isArray(ns)) return {};

            context = _.getObject(context);

            if(ns.length) {
                var key,
                    childContext = context;

                for (var n = 0; n < ns.length; n++) {
                    key = ns[n];
                    if (!_.has(childContext, key)) {
                        if(readOnly) {
                            childContext = {};
                            break;
                        }
                        else childContext[key] = {};
                    }
                    childContext = childContext[key];
                }
                if (childContext === context) childContext = null;
            }
            else childContext = context;

            return _.getObject(childContext);
        }
        ,getObjectFromNamespace: function(ns, context, defaultValue) {
            return _.getObject(this.getValueFromNamespace(ns, context), defaultValue);
        }
        ,getValueFromNamespace: function(ns, context, defaultValue) {
            if(_.isString(ns)) ns = ns.split('.');
            else if(!_.isArray(ns)) return defaultValue;

            var key = ns.pop();

            return this.getValue(this.getNamespace(ns, context, true)[key], defaultValue);
        }
        ,hasNamespace: function(ns, context) {
            if(!_.isObject(context)) return false;
            if(_.isString(ns)) ns = ns.split('.');

            if(_.isArray(ns)) {
                if(ns.length == 1) return _.has(context, ns);

                var key,
                    childContext = context;

                for (var n=0; n<ns.length; n++) {
                    key = ns[n];
                    if (!_.has(childContext, key)) return false;
                    childContext = childContext[key];
                }

                return true;
            }

            return false;
        }
        ,hasRole: function(role, user, storeId) {
            user = user || fp.user;
            if(!(user && user.id)) return false;

            var authorizedRoles = _.getArray(user.authorizations),
                cache = fp.cache.authorization[user.id] || (fp.cache.authorization[user.id] = {}),
                hasRole,
                cacheKey,
                roles;

            if(!role) role = fp.adminRoles;
            roles = _.isArray(role) ? role : [role];

            return _.find(roles, function(role) {
                if(_.isObject(role)) {
                    storeId = role.storeId;
                    role = role.role;
                }
                cacheKey = role + (storeId ? '_' + storeId : '');
                if(_.has(cache, cacheKey)) return cache[cacheKey];

                return _.find(authorizedRoles, function(item) {
                    hasRole = item.role_identifier == role && (!storeId || _.find(item.store_ids, function(value){return value == storeId || value == fpConfig.globalStoreId;}));
                    cache[cacheKey] = hasRole;
                    return hasRole;
                }) != null;
            }) != null;
        }
        ,isAuthenticated: function(user) {
            if(!user) user = fp.user;
            return fpUtil.getBoolean(
                fp.session.is_user_logged_in &&
                user.id &&
                user.user_status_identifier != 'registration_pending'
            );
        }
        ,isAuthorized: function(obj) {
            obj = _.getObject(obj);

            if(obj.authenticate && !this.isAuthenticated()) {
                return false;
            }

            if(obj.authorize) {
                var authorize = _.result(obj.authorize, null, obj.authorize);
                if (authorize && !_.isArray(authorize)) authorize = [authorize];

                return _.find(authorize, function (item) {
                    return fpUtil.hasRole(item);
                }) != null;
            }

            return true;
        }
        ,isGuestUser: function() {
            return fpUtil.getBoolean(
                fp.user &&
                fp.user.is_guest_user
            );
        }
        ,isSuperUser: function(user) {
            return fpUtil.hasRole(fpConstants.adminRole.ADMIN, user, fpConfig.globalStoreId);
        }
        ,getIntentRoleId: function(state, user) {
            var authorize = state.data && state.data.authorize,
                intentRoleId = [];

            if(authorize) {
                authorize = _.result(authorize, null, authorize);
                if (authorize && !_.isArray(authorize)) authorize = [authorize];

                var roleId;
                _.each(authorize, function (item) {
                    if(_.isObject(item)) item = item.role;
                    roleId = fpUtil.getIntentRoleIdByIdentifier(item, user);
                    if(roleId) intentRoleId.push(roleId);
                });
            }

            return intentRoleId.join();
        }
        ,getIntentRoleIdByIdentifier: function(identifier, user) {
            if(!identifier) return;

            user = _.getObject(user, fp.user);

            var authorization = _.findWhere(user.authorizations, {role_identifier: identifier});
            if (!authorization) return;

            return authorization.role_id;
        }
        ,sortItemsForGroup: function (items, options) {
            items = _.getArray(items);
            if(!_.size(items)) return items;
            options = _.getObject(options);

            var defaultObject = {},
                getDepartment = _.isFunction(options.getDepartment) ? options.getDepartment : $.proxy(this.getDepartment, this),
                sortHandler;

            if(options.group == 'department') {
                sortHandler = fpUtil
                    .sortFirstBy(function (item1, item2) {
                        return fpUtil.sortHelper(
                            _.getObject(getDepartment(item1), defaultObject).sequence,
                            _.getObject(getDepartment(item2), defaultObject).sequence
                        );
                    })
            }
            else {
                if(options.intent != 'order') {
                    sortHandler =
                        fpUtil
                            .sortFirstBy(function (item1, item2) {
                                return fpUtil.sortHelper(
                                    fpUtil.getValueFromNamespace('product.shopper_walkpath.sequence', item1),
                                    fpUtil.getValueFromNamespace('product.shopper_walkpath.sequence', item2)
                                );
                            })
                            .thenBy(function (item1, item2) {
                                return fpUtil.sortHelper(
                                    fpUtil.getValueFromNamespace('product.shopper_walkpath.name', item1),
                                    fpUtil.getValueFromNamespace('product.shopper_walkpath.name', item2)
                                );
                            });
                }

                var sortByWalkpathSequence = function (item1, item2) {
                    return fpUtil.sortHelper(
                        fpUtil.getValueFromNamespace('product.fulfillment_walkpath.sequence', item1),
                        fpUtil.getValueFromNamespace('product.fulfillment_walkpath.sequence', item2)
                    );
                };

                sortHandler = (sortHandler ? sortHandler.thenBy(sortByWalkpathSequence) : fpUtil.sortFirstBy(sortByWalkpathSequence))
                    .thenBy(function (item1, item2) {
                        return fpUtil.sortHelper(
                            fpUtil.getValueFromNamespace('product.fulfillment_walkpath.name', item1),
                            fpUtil.getValueFromNamespace('product.fulfillment_walkpath.name', item2)
                        );
                    })
                    .thenBy(function (item1, item2) {
                        return fpUtil.sortHelper(
                            fpUtil.getValueFromNamespace('product.fulfillment_walkpath_sequence_within', item1),
                            fpUtil.getValueFromNamespace('product.fulfillment_walkpath_sequence_within', item2)
                        );
                    })
                    .thenBy(function (item1, item2) {
                        //force empty location to bottom by using a default of 'zzzzzz'
                        return fpUtil.sortHelper(
                            fpUtil.getValueFromNamespace('product.location', item1, 'zzzzzz'),
                            fpUtil.getValueFromNamespace('product.location', item2, 'zzzzzz')
                        );
                    });

                if(options.intent == 'order') {
                    var getFulfillmentName = options.getFulfillmentName;
                    if(_.isFunction(getFulfillmentName)) {
                        sortHandler = sortHandler.thenBy(function (item1, item2) {
                            return fpUtil.sortHelper(getFulfillmentName(item1), getFulfillmentName(item2));
                        });
                    }

                    sortHandler = sortHandler.thenBy(function (item1, item2) {
                        return fpUtil.sortHelper(
                            _.getObject(getDepartment(item1), defaultObject).path,
                            _.getObject(getDepartment(item2), defaultObject).path
                        );
                    });
                }
            }

            return items.sort(
                sortHandler
                    .thenBy(function (item1, item2) {
                        return fpUtil.sortHelper(
                            fpUtil.getValueFromNamespace('product.name', item1, !options.disableNameFallback ? item1.name : undefined),
                            fpUtil.getValueFromNamespace('product.name', item2, !options.disableNameFallback ? item2.name : undefined)
                        );
                    })
                    .thenBy(function (item1, item2) {
                        return fpUtil.sortHelper(
                            fpUtil.getValueFromNamespace('product.id', item1),
                            fpUtil.getValueFromNamespace('product.id', item2)
                        );
                    })
                    .thenBy(function (item1, item2) {
                        return fpUtil.sortHelper(item1.order_id, item2.order_id);
                    })
            );
        }
        ,getDepartment: function(item) {
            if(!item) return;
            if(_.isString(item)) return fp.departmentHash[item];

            var product = this.getProduct(item);
            if(!product) return;
            var id = _.first(product.department_ids);
            return id && fp.departmentHash[id];
        }
        ,getTopDepartment: function(item, depth) {
            if(!item) return;

            var dept = this.getDepartment(item),
                parents = [],
                hashedIds = {},
                value;

            while(dept) {
                parents.unshift(dept);
                if(!dept.parent_id) break;

                value = fp.departmentHash[dept.parent_id];
                if(value) dept = value;
                else break;

                if(hashedIds[dept.id]) {
                    fp.warn(this.formatString('Circular reference detected for department {0}.', dept.id));
                    break;
                }

                hashedIds[dept.id] = 1;
            }

            if(depth && parents.length) {
                var index = (depth < parents.length ? depth : parents.length) - 1;
                dept = parents[index];
            }

            return dept;
        }
        ,getFormattedAddress: function(obj, prefix, delimiter, enableCountry, fnEncode) {
            if(!_.isObject(obj)) return '';

            prefix = S.getString(prefix);

            var address = '',
                fnEncode = $.proxy(_.getFunction(fnEncode, this.encodeForHtml), this),
                addressPart;

            if(!prefix && !obj.has_address && obj.address_0) {
                address = fnEncode(obj.address_0);
            }
            else {
                delimiter = S.getString(delimiter, ' <br/>');

                var addressPrefix = prefix + 'address_',
                    city = obj[prefix + 'city'],
                    state = obj[prefix + 'state'],
                    postalCode = obj[prefix + 'postal_code'],
                    country = obj[prefix + 'country'];

                for (var n = 0; n <= 3; n++) {
                    addressPart = fnEncode(obj[addressPrefix + n]);
                    if (!addressPart) continue;

                    if (address) address += delimiter;
                    address += addressPart;
                }

                addressPart = '';
                if (city) addressPart = fnEncode(city);
                if (state || postalCode) {
                    if (addressPart) addressPart += ', ';
                    if (state) addressPart += fnEncode(state);
                    if (!obj.disablePostal && postalCode) {
                        if (state) addressPart += ' ';
                        addressPart += fnEncode(postalCode);
                    }
                }

                if (addressPart) {
                    if (address) address += delimiter;
                    address += addressPart;
                }
                if (enableCountry && country) {
                    if (address) address += delimiter;
                    address += fnEncode(country);
                }
            }

            return address;
        }
        ,isNewItem: function(item) {
            if(!item) return true;
            var id = _.isObject(item) ? item.id : item;
            return S(id).startsWith(fpConstants.NEW_ITEM_PREFIX, true);
        }
        ,getNewItemId: function() {
            return _.uniqueId(fpConstants.NEW_ITEM_PREFIX);
        }
        ,treeify: function(items, options) {
            items = _.getArray(items);
            options = _.defaults(options, {
                idField: 'id',
                parentField: 'parent_id',
                childrenField: 'children'
            });

            var idField = options.idField,
                parentField = options.parentField,
                childrenField = options.childrenField,
                sortBy = options.sortBy,
                asHash = !fpUtil.isNull(options.asHash) ? options.asHash : !fpUtil.isNull(options.hash),
                enableConcatChildren = options.enableConcatChildren,
                requireChildren = options.requireChildren,
                hash = _.getObject(options.hash),
                groups = _.groupBy(items, parentField),
                itemId,
                children,
                childrenItemId,
                hashedChildren;

            items = _.filter(items, function(item) {
                itemId = item[idField];
                if(itemId) {
                    children = groups[itemId];
                    if(children) {
                        if(enableConcatChildren) {
                            hashedChildren = _.indexBy(children, idField);
                            _.each(item[childrenField], function(childItem) {
                                childrenItemId = childItem[idField];
                                if(!hashedChildren[childrenItemId]) {
                                    hashedChildren[childrenItemId] = childItem;
                                    if(asHash) hash[childrenItemId] = childItem;
                                    children.push(childItem);
                                }
                            });
                        }
                        if (sortBy) fpUtil.sort(children, sortBy);
                        item[childrenField] = children;
                    }
                    if(children || !requireChildren) {
                        if(asHash) hash[itemId] = item;
                        return true;
                    }
                }
            });

            if (!asHash && sortBy) fpUtil.sort(items, sortBy);

            return asHash ? hash : items;
        }
        ,getXhrErrorResponse: function(jqXHR, textStatus, errorThrown) {
            if(_.isString(jqXHR)) errorThrown = jqXHR;
            if(errorThrown == 'error') errorThrown = undefined;

            jqXHR = _.getObject(jqXHR);
            var resp;
            if (_.isObject(jqXHR.responseJSON)) resp = jqXHR.responseJSON;
            else if (_.isObject(jqXHR.response)) resp = jqXHR.response; //multiplex calls may have a response object
            else if (jqXHR[2]) resp = jqXHR[2];
            else if(_.hasAny(jqXHR, ['error_code', 'error_message'])) resp = jqXHR;

            resp = _.isObject(resp) ? resp : {error_code: textStatus || jqXHR.status, error_message: S.getString(resp, errorThrown)};

            return resp;
        }
        ,applyCallback: function (onSuccess, onFailure, always, promise) {
            if(!_.isObject(promise)) promise = $.Deferred().promise();

            promise.done(onSuccess);

            if(_.isFunction(onFailure)) {
                promise.fail(function(jqXHR) {
                    onFailure(fpUtil.getXhrErrorResponse(jqXHR));
                });
            }

            promise.always(always);

            return promise;
        }
        ,getClientLocation: function(clientLocationTimeout) {            
            const deferred = $.Deferred(),
                defaultTimeout = 5000;
            if(!this.__deferredGoogleLoader) {
                delete this.__clientLocationTimeout;

                if(fp.isBot) this.__clientLocationTimeout = 0;
                else {
                    if(!fpUtil.isNull(clientLocationTimeout)) {
                        if(clientLocationTimeout) {
                            this.__clientLocationTimeout = _.isBoolean(clientLocationTimeout) ? defaultTimeout : clientLocationTimeout;
                        }
                    }
                    else {
                        this.__clientLocationTimeout = defaultTimeout;
                    }
                }

                this.__deferredGoogleLoader = $.Deferred();

                // this.showProgress();

                var scriptId = 'fp-gcharts-loader';

                _.defer(function () {
                    var onGoogleLoaderCallbackProxy = $.proxy(onGoogleLoaderCallback, fpUtil);

                    if ($('#' + scriptId).length) onGoogleLoaderCallbackProxy(true);
                    else {
                        fpUtil.__googleLoaderTimeoutId = _.delay(onGoogleLoaderCallbackProxy, 2000, true);
                        fpUi.loadScript('https://www.gstatic.com/charts/loader.js', null, {id: scriptId})
                            .always(function() {
                                onGoogleLoaderCallbackProxy();
                            });
                    }
                });
            }

            this.__deferredGoogleLoader
                .done(deferred.resolve)
                .fail(deferred.reject);

            return deferred.promise();
        }
        ,ensureStore: function(options) {
            options = _.getObject(options);
            var priceRequiredModeId = S(this.map.get('storePriceMode').get('price_required').id);
            if(fp.store.id && (options.disablePriceRequired || priceRequiredModeId.eq(fp.store.price_mode_id))) {
                return $.when();
            }

            var store;

            function redirectStoreLocator() {
                if(store && (options.disablePriceRequired || priceRequiredModeId.eq(store.price_mode_id))) {
                    return fp.setStore(store);
                }

                var stateManager = fp.ui.router.stateManager;
                stateManager.go(fpConfig.routeStates.storeLocator, {
                    next: stateManager.href(stateManager.current, $.extend({}, stateManager.stateParams)),
                    intent: options.intent
                });

                return $.Deferred().reject().promise();
            }

            if(!options.enableSetStoreByLocation) return redirectStoreLocator();

            return this.getClientLocation()
                .then(function(position) {
                    if(!(position.latitude && position.longitude)) {
                        if(options.enableFirstStoreFallback) store = fp.singleStore;
                        return;
                    }

                    return fpService.storeService.get({
                            latitude: position.latitude,
                            longitude: position.longitude,
                            has_address: true,
                            limit: 1
                        })
                        .done(function (resp) {
                            store = _.first(resp.items);
                        });
                })
                .then(redirectStoreLocator, redirectStoreLocator);
        }
        ,getItemDetailClass: function(item, intent) {
            init = S.getString(intent, fpConfig.intent);
            var className = ['fp-item-detail'];
            if(_.isObject(item)) {
                var product = this.getProduct(item);
                if(intent != 'admin') {
                    switch(this.map.get('productStatus').get(product.status_id).identifier) {
                        case 'not_available':
                            className.push('fp-is-item-detail-not-available');
                            break;
                        case 'no_movement':
                            if(fpUtil.map.get('spcProductData', null, true).get('product_inventory').id && product.enforce_product_inventory) {
                                className.push('fp-is-item-detail-no-movement');
                            }
                            break;
                        //no default
                    }
                }
                if(this.getPriceDisclaimer(product)) className.push('fp-has-item-detail-price-disclaimer');
                if(item.sale_price || product.sale_price) className.push('fp-is-item-detail-sale');
                if(this.getItemHasSaleModifier(product)) className.push('fp-is-item-detail-sale-modifier');
            }

            return className.join(' ');
        }
        ,toggleText: function(element, a, b) {
            element.html(element.html() == b ? a : b);
        }
        ,hexToRgb: function (hex) {
            var bigint = parseInt(S(hex).trimLeft('#').s, 16),
                r = (bigint >> 16) & 255,
                g = (bigint >> 8) & 255,
                b = bigint & 255;
        
            return 'rgb(' + r + ', ' + g + ', ' + b + ')';
        }
        // is 50% in view
        ,isInViewport: function($element){
            var elementTop = $element.offset().top,
                elementLeft = $element.offset().left,
                viewportLeft = $(window).scrollLeft(),
                viewportRight = $(window).width(),
                elementMiddleHeight = elementTop + $element.outerHeight()/2,
                elementMiddleWidth = elementLeft + $element.outerWidth()/2,
                viewportTop = $(window).scrollTop(),
                viewportBottom = viewportTop + $(window).height();

            return elementMiddleHeight > viewportTop && elementMiddleHeight < viewportBottom && elementMiddleWidth > viewportLeft && elementMiddleWidth < viewportRight;
        }
        ,initAndApplyTransend: function(payload, fromInitLogin) {
            const urlParams = fpUi.router.routeManager.urlParams;
            const trackingConfig = _.getObject(_.isArray(fpConfig.modules.tracking) ?
                _.findWhere(fpConfig.modules.tracking, {transcendEnabled: true}) :
                fpConfig.modules.tracking);

            if(
                !fp.isProd() &&
                !fp.isStage() &&
                !(fp.isPreProd() && trackingConfig.enableOnPreProd) &&
                urlParams.enable_tracking !== 'true' &&
                urlParams.log_tracking !== 'true'
            ) {
                return;
            }

            if(trackingConfig.transcendEnabled && window.airgap) {
                const transcendData = airgap.getConsent();

                if(payload && fromInitLogin) {
                    if(transcendData?.updated) {
                        payload.consent_purpose = transcendData.purposes?.SaleOfInfo;
                        payload.updated_at = transcendData.timestamp;

                        fp.__lastTranscendConsentData = transcendData;
                    }
                }

                if(!fp.__airgapListener) {
                    fp.__airgapListener = true;
                    airgap.addEventListener('consent-change', function(event) {
                        if(fpUtil.isAuthenticated()) {
                            const transcendData = event.detail?.consent;
                            if(transcendData?.updated) {
                                if(
                                    _.isObject(fp.__lastTranscendConsentData) &&
                                    transcendData.purposes?.SaleOfInfo == fp.__lastTranscendConsentData.purposes?.SaleOfInfo
                                ) {
                                    return;
                                }

                                fp.__lastTranscendConsentData = transcendData;

                                fpService.sessionService
                                    .get({
                                        id: fp.session.token,
                                        consent_purpose: transcendData.purposes?.SaleOfInfo,
                                        updated_at: transcendData.timestamp
                                    }, {
                                        handleErrors: false,
                                        ignoreErrors: 'sign_out_required',
                                        formatForRestfulId: true
                                    });
                            }
                        }
                    });
                }
            }
        }
    };

    function onGoogleLoaderCallback(force) {
        if(!(this.__googleLoaderTimeoutId || force)) return;

        clearTimeout(this.__googleLoaderTimeoutId);
        delete this.__googleLoaderTimeoutId;

        var position = {},
            callbackProxy = function(pos) {
                clearTimeout(timeoutId);

                if(fpUtil.__deferredGoogleLoader) {
                    pos = _.getObject(pos);

                    position.latitude = pos.coords?.latitude || pos.latitude;
                    position.longitude = pos.coords?.longitude || pos.longitude;

                    fpUtil.__deferredGoogleLoader.resolve(position);
                    delete fpUtil.__deferredGoogleLoader;
                }
            },
            timeoutId;

        if(window.google && google.loader && google.loader.ClientLocation) {
            callbackProxy(google.loader.ClientLocation);
        }
        else if(navigator.geolocation && (window.location.protocol == 'https:' || fp.isLocal())) {
            navigator.geolocation.getCurrentPosition(
                callbackProxy,
                callbackProxy, {
                    enableHighAccuracy: false,
                    maximumAge: 60 * 60 * 1000, //1 hour
                    timeout: this.__clientLocationTimeout
                }
            );

            //navigator.geolocation.getCurrentPosition timeout is currently not working for Chrome and Firefox
            if(this.__clientLocationTimeout) timeoutId = _.delay(callbackProxy, this.__clientLocationTimeout);
        }
        else callbackProxy();
    }
})();